export const SITE_ADDRESSES = {
  ABE1: {
    name: "ABE1 - FDFC (Allentown, PA)",
    addressLine1: "6370 Hedgewood Dr",
    addressLine2: "",
    zipCode: "18106",
    city: "Allentown",
    state: "PA",
    country: "US",
    unitNumber: "1450",
  },
  ABE2: {
    name: "ABE2 - Sortable FC (Breinigsville, PA)",
    addressLine1: "705 Boulder Drive",
    addressLine2: "",
    zipCode: "18031",
    city: "Breinigsville",
    state: "PA",
    country: "US",
    unitNumber: "1463",
  },
  ABE3: {
    name: "ABE3 - Sortable FC (Breinigsville, PA)",
    addressLine1: "650 Boulder Drive",
    addressLine2: "",
    zipCode: "18031",
    city: "Breinigsville",
    state: "PA",
    country: "US",
    unitNumber: "1424",
  },
  ABE4: {
    name: "ABE4 - NonSort FC (Easton, PA)",
    addressLine1: "1610 Van Buren Road",
    addressLine2: "",
    zipCode: "18045",
    city: "Easton",
    state: "PA",
    country: "US",
    unitNumber: "1829",
  },
  ABE5: {
    name: "ABE5 - MbA (Norristown, PA)",
    addressLine1: "2455 Boulevard of the Generals",
    addressLine2: "",
    zipCode: "19403",
    city: "Norristown",
    state: "PA",
    country: "US",
    unitNumber: "2625",
  },
  ABE8: {
    name: "ABE8 - Sortable FC (Florence, NJ)",
    addressLine1: "309 Cedar Lane",
    addressLine2: "",
    zipCode: "08518",
    city: "Florence",
    state: "NJ",
    country: "US",
    unitNumber: "1848",
  },
  ABQ1: {
    name: "ABQ1 - FC (Albuquerque, NM)",
    addressLine1: "12945 Ladera Drive NW",
    addressLine2: "",
    zipCode: "87120",
    city: "ALBUQUERQUE",
    state: "NM",
    country: "US",
    unitNumber: "1W20",
  },
  ABQ2: {
    name: "ABQ2 - FC NONSORT TNS (Los Lunas, NM)",
    addressLine1: "6251 Pioneer Trail NW LosLunas",
    addressLine2: "",
    zipCode: "87031",
    city: "Los Lunas",
    state: "NM",
    country: "US",
    unitNumber: "7Z41",
  },
  ABQ5: {
    name: "ABQ5 - Sort Center (Albuquerque, NM)",
    addressLine1: "15480 Reservoir Rd NW",
    addressLine2: "",
    zipCode: "87121",
    city: "ALBUQUERQUE",
    state: "NM",
    country: "US",
    unitNumber: "3G62",
  },
  ACY1: {
    name: "ACY1 - Sortable FC ARS (West Deptford, NJ)",
    addressLine1: "240 MANTUA GROVE RD",
    addressLine2: "",
    zipCode: "08066",
    city: "WEST DEPTFORD",
    state: "NJ",
    country: "US",
    unitNumber: "2526",
  },
  ACY2: {
    name: "ACY2 - Sortable FC TNS (Burlington, NJ)",
    addressLine1: "1101 E PEARL ST",
    addressLine2: "",
    zipCode: "08016",
    city: "BURLINGTON",
    state: "NJ",
    country: "US",
    unitNumber: "2529",
  },
  ACY5: {
    name: "ACY5 - SortCenter (Logan Township, NJ)",
    addressLine1: "2277 Center Square Rd",
    addressLine2: "",
    zipCode: "08085",
    city: "Logan Township",
    state: "NJ",
    country: "US",
    unitNumber: "1559",
  },
  ACY8: {
    name: "ACY8 - Sort Center (Burlington, NJ)",
    addressLine1: "8 CAMPUS DR",
    addressLine2: "",
    zipCode: "08016",
    city: "BURLINGTON",
    state: "NJ",
    country: "US",
    unitNumber: "3B75",
  },
  ACY9: {
    name: "ACY9 - Sort Center (Logan Township, NJ)",
    addressLine1: "1150 COMMERCE BLVD",
    addressLine2: "",
    zipCode: "08085",
    city: "LOGAN TOWNSHIP",
    state: "NJ",
    country: "US",
    unitNumber: "3G63",
  },
  AGS1: {
    name: "AGS1 - FC Sortable (Appling, GA)",
    addressLine1: "2150 DISCOVERY DR",
    addressLine2: "",
    zipCode: "30802",
    city: "APPLING",
    state: "GA",
    country: "US",
    unitNumber: "1I99",
  },
  AGS2: {
    name: "AGS2 - Supplemental FC (Jefferson, GA)",
    addressLine1: "429 Toy Wright Road",
    addressLine2: "",
    zipCode: "30549",
    city: "Jefferson",
    state: "GA",
    country: "US",
    unitNumber: "1I37",
  },
  AGS3: {
    name: "AGS3 - FC (Appling, GA)",
    addressLine1: "785 Innovation Parkway",
    addressLine2: "",
    zipCode: "30802",
    city: "APPLING",
    state: "GA",
    country: "US",
    unitNumber: "3W82",
  },
  AGS5: {
    name: "AGS5 - Sort Center (Appling, GA)",
    addressLine1: "785 INNOVATION PKWY",
    addressLine2: "",
    zipCode: "30802",
    city: "APPLING",
    state: "GA",
    country: "US",
    unitNumber: "3G64",
  },
  AKC1: {
    name: "AKC1 - FC (Akron, OH)",
    addressLine1: "2450 ROMIG RD",
    addressLine2: "",
    zipCode: "44320",
    city: "AKRON",
    state: "OH",
    country: "US",
    unitNumber: "2117",
  },
  AKH4: {
    name: "AKH4 - MBA (Gastonia, NC)",
    addressLine1: "525 Scalybark Rd",
    addressLine2: "",
    zipCode: "28054",
    city: "GASTONIA",
    state: "NC",
    country: "US",
    unitNumber: "7Z05",
  },
  AKR1: {
    name: "AKR1 - Non Sortable FC TNS (Canton, OH)",
    addressLine1: "4747 Rebar Ave NE",
    addressLine2: "",
    zipCode: "44705",
    city: "Canton",
    state: "OH",
    country: "US",
    unitNumber: "7Z75",
  },
  ALB1: {
    name: "ALB1 - NonSort FC (Castleton, NY)",
    addressLine1: "1835 US ROUTE 9",
    addressLine2: "",
    zipCode: "12033",
    city: "Castleton",
    state: "NY",
    country: "US",
    unitNumber: "2134",
  },
  ALB5: {
    name: "ALB5 - Sort Center (Castleton-On-Hudson, NY)",
    addressLine1: "1710 Schodack Valley Road",
    addressLine2: "",
    zipCode: "12033",
    city: "Castleton",
    state: "NY",
    country: "US",
    unitNumber: "3M32",
  },
  ATL2: {
    name: "ATL2 - FC (Stone Mountain, GA)",
    addressLine1: "2255 W PARK PLACE BLVD",
    addressLine2: "",
    zipCode: "30087",
    city: "STONE MOUNTAIN",
    state: "GA",
    country: "US",
    unitNumber: "2121",
  },
  ATL6: {
    name: "ATL6 - SortCenter (East Point, GA)",
    addressLine1: "4200 North Commerce Drive",
    addressLine2: "",
    zipCode: "30349",
    city: "East Point",
    state: "GA",
    country: "US",
    unitNumber: "1575",
  },
  ATL7: {
    name: "ATL7 - Supplemental FC (Union City, GA)",
    addressLine1: "6855 SHANNON PKWY",
    addressLine2: "",
    zipCode: "30291",
    city: "UNION CITY",
    state: "GA",
    country: "US",
    unitNumber: "1497",
  },
  AVP1: {
    name: "AVP1 - (Hazleton, PA)",
    addressLine1: "550 Oak Ridge Rd",
    addressLine2: "",
    zipCode: "18202",
    city: "Hazleton",
    state: "PA",
    country: "US",
    unitNumber: "1480",
  },
  AVP8: {
    name: "AVP8 - Supplemental FC (Pittston, PA)",
    addressLine1: "250 Enterprise Way",
    addressLine2: "",
    zipCode: "18640",
    city: "Pittston",
    state: "PA",
    country: "US",
    unitNumber: "1349",
  },
  AZA2: {
    name: "AZA2 - GSOC (Goodyear, AZ)",
    addressLine1: "555 N Litchfield Road",
    addressLine2: "",
    zipCode: "85338",
    city: "Goodyear",
    state: "AZ",
    country: "US",
    unitNumber: "2032",
  },
  AZA5: {
    name: "AZA5 - Sort Center (Phoenix, AZ)",
    addressLine1: "6000 West Van Buren Street",
    addressLine2: "",
    zipCode: "85043",
    city: "PHOENIX",
    state: "AZ",
    country: "US",
    unitNumber: "1164",
  },
  AZA9: {
    name: "AZA9 - Sort Center (Glendale, AZ)",
    addressLine1: "6395 N. Sarival Avenue",
    addressLine2: "",
    zipCode: "85340",
    city: "GLENDALE",
    state: "AZ",
    country: "US",
    unitNumber: "3G65",
  },
  BDL2: {
    name: "BDL2 - Sortable FC (Windsor, CT)",
    addressLine1: "200 Old Iron Ore Rd",
    addressLine2: "",
    zipCode: "06095",
    city: "Windsor",
    state: "CT",
    country: "US",
    unitNumber: "1447",
  },
  BDL3: {
    name: "BDL3 - Sortable FC ARS (North Haven, CT)",
    addressLine1: "409 Washington Avenue",
    addressLine2: "",
    zipCode: "06473",
    city: "North Haven",
    state: "CT",
    country: "US",
    unitNumber: "2437",
  },
  BDL4: {
    name: "BDL4 - FC Sortable (Windsor, CT)",
    addressLine1: "1215 KENNEDY RD",
    addressLine2: "",
    zipCode: "06095",
    city: "WINDSOR",
    state: "CT",
    country: "US",
    unitNumber: "1W26",
  },
  BDL5: {
    name: "BDL5 - SortCenter (Wallingford, CT)",
    addressLine1: "29 Research Parkway",
    addressLine2: "",
    zipCode: "06492",
    city: "Wallingford",
    state: "CT",
    country: "US",
    unitNumber: "1581",
  },
  BDL7: {
    name: "BDL7 - MOD (North Haven, CT)",
    addressLine1: "409 Washington Ave",
    addressLine2: "",
    zipCode: "06473",
    city: "North Haven",
    state: "CT",
    country: "US",
    unitNumber: "4A90",
  },
  BDU2: {
    name: "BDU2 - FC (Commerce City, CO)",
    addressLine1: "8350 Quintero St",
    addressLine2: "",
    zipCode: "80022",
    city: "COMMERCE CITY",
    state: "CO",
    country: "US",
    unitNumber: "3W67",
  },
  BDU5: {
    name: "BDU5 - Sort Center (Commerce City, CO)",
    addressLine1: "8350 Quintero St",
    addressLine2: "",
    zipCode: "80022",
    city: "COMMERCE CITY",
    state: "CO",
    country: "US",
    unitNumber: "3G59",
  },
  BFL1: {
    name: "BFL1 - Sortable FC ARS (Bakersfield, CA)",
    addressLine1: "1601 Petrol Road",
    addressLine2: "",
    zipCode: "93308",
    city: "BAKERSFIELD",
    state: "CA",
    country: "US",
    unitNumber: "2118",
  },
  BFL2: {
    name: "BFL2 - FC Sortable (Shafter, CA)",
    addressLine1: "4500 EXPRESS AVE",
    addressLine2: "",
    zipCode: "93263",
    city: "SHAFTER",
    state: "CA",
    country: "US",
    unitNumber: "1I46",
  },
  BFN1: {
    name: "BFN1- NonSortFC (Baltimore, MD)",
    addressLine1: "6001 BETHLEHEM BLVD",
    addressLine2: "",
    zipCode: "21219",
    city: "SPARROWS POINT",
    state: "MD",
    country: "US",
    unitNumber: "1B00",
  },
  BHM1: {
    name: "BHM1 - FC (Bessemer, AL)",
    addressLine1: "975 Powder Plant Rd",
    addressLine2: "",
    zipCode: "35022",
    city: "BESSEMER",
    state: "AL",
    country: "US",
    unitNumber: "2075",
  },
  BLV2: {
    name: "BLV2 - FC (Berkeley, MO)",
    addressLine1: "8850 Springdale Ave",
    addressLine2: "",
    zipCode: "63134",
    city: "Berkeley",
    state: "MO",
    country: "US",
    unitNumber: "3W70",
  },
  BNA2: {
    name: "BNA2 - NonSort FC (Lebanon, TN)",
    addressLine1: "500 DUKE DR",
    addressLine2: "",
    zipCode: "37090",
    city: "LEBANON",
    state: "TN",
    country: "US",
    unitNumber: "1445",
  },
  BNA3: {
    name: "BNA3 - Sortable FC (Murfreesboro, TN)",
    addressLine1: "2020 JOE B JACKSON PKWY",
    addressLine2: "",
    zipCode: "37127",
    city: "MURFREESBORO",
    state: "TN",
    country: "US",
    unitNumber: "1421",
  },
  BNA5: {
    name: "BNA5 - SortCenter (Nashville, TN)",
    addressLine1: "50 Airways Blvd.",
    addressLine2: "",
    zipCode: "37217",
    city: "Nashville",
    state: "TN",
    country: "US",
    unitNumber: "1816",
  },
  BNA7: {
    name: "BNA7 - Sort Center (Mt. Juliet, TN)",
    addressLine1: "23 Athlete's Way",
    addressLine2: "",
    zipCode: "37122",
    city: "Mt. Juliet",
    state: "TN",
    country: "US",
    unitNumber: "3M34",
  },
  BNA8: {
    name: "BNA8 - Sort Center (Lebanon, TN)",
    addressLine1: "100 DAVID PHILLIPS DR",
    addressLine2: "",
    zipCode: "37090",
    city: "LEBANON",
    state: "TN",
    country: "US",
    unitNumber: "3M09",
  },
  BNA9: {
    name: "BNA9 - Sort Center (La Vergne, TN)",
    addressLine1: "700 Mason RoadPark 24",
    addressLine2: "Building 7",
    zipCode: "37086",
    city: "LA VERGNE",
    state: "TN",
    country: "US",
    unitNumber: "3G08",
  },
  BOI2: {
    name: "BOI2 - FC (Nampa, ID)",
    addressLine1: "5295 E. Franklin Road",
    addressLine2: "",
    zipCode: "83687",
    city: "NAMPA",
    state: "ID",
    country: "US",
    unitNumber: "2074",
  },
  BOI5: {
    name: "BOI5 - Sort Center (Boise, ID)",
    addressLine1: "2155 E Freight Street",
    addressLine2: "",
    zipCode: "83716",
    city: "BOISE",
    state: "ID",
    country: "US",
    unitNumber: "3G67",
  },
  BOS3: {
    name: "BOS3 - Sortable FC (North Andover, MA)",
    addressLine1: "1450 OSGOOD ST",
    addressLine2: "",
    zipCode: "01845",
    city: "NORTH ANDOVER",
    state: "MA",
    country: "US",
    unitNumber: "8026",
  },
  BOS4: {
    name: "BOS4 - Sort Center (Milford, MA)",
    addressLine1: "1 National Street",
    addressLine2: "",
    zipCode: "01757",
    city: "MILFORD",
    state: "MA",
    country: "US",
    unitNumber: "3B53",
  },
  BOS5: {
    name: "BOS5 - SortCenter (Stoughton, MA)",
    addressLine1: "1000 Technology Center Drive",
    addressLine2: "",
    zipCode: "02072",
    city: "Stoughton",
    state: "MA",
    country: "US",
    unitNumber: "1577",
  },
  BOS7: {
    name: "BOS7 - NonSort FC (Fall River, MA)",
    addressLine1: "1180 Innovation Way",
    addressLine2: "",
    zipCode: "02720",
    city: "Fall River",
    state: "MA",
    country: "US",
    unitNumber: "1555",
  },
  BUF5: {
    name: "BUF5 - SortCenter (Buffalo, NY)",
    addressLine1: "4201 Walden Ave",
    addressLine2: "",
    zipCode: "14086",
    city: "Lancaster",
    state: "NY",
    country: "US",
    unitNumber: "1160",
  },
  BUF9: {
    name: "BUF9 - FC (Lancaster, NY)",
    addressLine1: "4201 Walden Avenue",
    addressLine2: "",
    zipCode: "14086",
    city: "Lancaster",
    state: "NY",
    country: "US",
    unitNumber: "7J06",
  },
  BUR7: {
    name: "BUR7 - FC (Mira Loma, CA)",
    addressLine1: "11200 Iberia Street",
    addressLine2: "",
    zipCode: "91752",
    city: "MIRA LOMA",
    state: "CA",
    country: "US",
    unitNumber: "3W61",
  },
  BWI1: {
    name: "BWI1 - FDFC (Jessup, VA)",
    addressLine1: "45121 Global Plaza",
    addressLine2: "",
    zipCode: "20166",
    city: "Sterling",
    state: "VA",
    country: "US",
    unitNumber: "1451",
  },
  BWI2: {
    name: "BWI2 - Sortable FC (Baltimore, MD)",
    addressLine1: "2010 Broening Hwy",
    addressLine2: "",
    zipCode: "21224",
    city: "Baltimore",
    state: "MD",
    country: "US",
    unitNumber: "1439",
  },
  BWI4: {
    name: "BWI4 - NonSort FC TNS (Clear Brook, VA)",
    addressLine1: "165 Business Blvd",
    addressLine2: "",
    zipCode: "22624",
    city: "Clear Brook",
    state: "VA",
    country: "US",
    unitNumber: "2425",
  },
  BWI5: {
    name: "BWI5 - SortCenter (Baltimore City, MD)",
    addressLine1: "5501 Holabird Ave",
    addressLine2: "",
    zipCode: "21224",
    city: "Baltimore",
    state: "MD",
    country: "US",
    unitNumber: "1560",
  },
  CAE1: {
    name: "CAE1 - Sortable FC (West Columbia, SC)",
    addressLine1: "4400 12th Street Extension",
    addressLine2: "",
    zipCode: "29172",
    city: "West Columbia",
    state: "SC",
    country: "US",
    unitNumber: "1419",
  },
  CAE3: {
    name: "CAE3 - MOD (West Columbia, SC)",
    addressLine1: "222 Old Wire Road",
    addressLine2: "",
    zipCode: "29172",
    city: "West Columbia",
    state: "SC",
    country: "US",
    unitNumber: "2439",
  },
  CAK4: {
    name: "CAK4 - MBA (Valley View, OH)",
    addressLine1: "10242 State Route 43",
    addressLine2: "",
    zipCode: "44241",
    city: "STREETSBORO",
    state: "OH",
    country: "US",
    unitNumber: "8A89",
  },
  CDW5: {
    name: "CDW5 - SortCenter (Carteret, NJ)",
    addressLine1: "380 MIDDLESEX AVENUE",
    addressLine2: "",
    zipCode: "07008",
    city: "CARTERET",
    state: "NJ",
    country: "US",
    unitNumber: "3B72",
  },
  CDW9: {
    name: "CDW9 - Sort Center (Burlington, NJ)",
    addressLine1: "1900 RIVER RD",
    addressLine2: "",
    zipCode: "08016",
    city: "BURLINGTON",
    state: "NJ",
    country: "US",
    unitNumber: "3G07",
  },
  CHA1: {
    name: "CHA1 - ReLo Sort FC (Chattanooga, TN)",
    addressLine1: "7200 Discovery Dr",
    addressLine2: "",
    zipCode: "37416",
    city: "Chattanooga",
    state: "TN",
    country: "US",
    unitNumber: "1418",
  },
  CHA2: {
    name: "CHA2 - NonSort FC (Charleston, TN)",
    addressLine1: "225 Infinity Dr NW",
    addressLine2: "",
    zipCode: "37310",
    city: "Charleston",
    state: "TN",
    country: "US",
    unitNumber: "1425",
  },
  CHO1: {
    name: "CHO1 - TNS FC (Fishersville, VA)",
    addressLine1: "32 Trader Road",
    addressLine2: "",
    zipCode: "22939",
    city: "Fishersville",
    state: "VA",
    country: "US",
    unitNumber: "7Z48",
  },
  CHS1: {
    name: "CHS1 - CreateSpace MOD Disabled (Charleston, SC)",
    addressLine1: "7290-B Investment Dr.",
    addressLine2: "",
    zipCode: "29418",
    city: "North Charleston",
    state: "SC",
    country: "US",
    unitNumber: "1115",
  },
  CLE2: {
    name: "CLE2 - Sortable FC ARS (North Randall, OH)",
    addressLine1: "21500 EMERY RD",
    addressLine2: "",
    zipCode: "44128",
    city: "NORTH RANDALL",
    state: "OH",
    country: "US",
    unitNumber: "2440",
  },
  CLE3: {
    name: "CLE3 - Sortable FC ARS (Euclid, OH)",
    addressLine1: "1155 Babbitt Road",
    addressLine2: "",
    zipCode: "44132",
    city: "Euclid",
    state: "OH",
    country: "US",
    unitNumber: "2535",
  },
  CLE5: {
    name: "CLE5 - SortCenter (Cleveland, OH)",
    addressLine1: "8685 Independence Pkwy, Twinsburg, OH 44087",
    addressLine2: "",
    zipCode: "44087",
    city: "Twinsburg",
    state: "OH",
    country: "US",
    unitNumber: "1051",
  },
  CLE9: {
    name: "CLE9 - Sort Center (Valley View, OH)",
    addressLine1: "5585 CANAL RD",
    addressLine2: "",
    zipCode: "44125",
    city: "CLEVELAND",
    state: "OH",
    country: "US",
    unitNumber: "3G68",
  },
  CLT2: {
    name: "CLT2 - Sortable FC (Charlotte, NC)",
    addressLine1: "10240 Old Dowd Rd",
    addressLine2: "",
    zipCode: "28214",
    city: "Charlotte",
    state: "NC",
    country: "US",
    unitNumber: "1048",
  },
  CLT3: {
    name: "CLT3 - Sortable FC TNS (Kannapolis, NC)",
    addressLine1: "6500 Davidson Hwy",
    addressLine2: "",
    zipCode: "28027",
    city: "Concord",
    state: "NC",
    country: "US",
    unitNumber: "2532",
  },
  CLT4: {
    name: "CLT4 - FC (Charlotte, NC)",
    addressLine1: "8000 TUCKASEEGEE RD",
    addressLine2: "",
    zipCode: "28214",
    city: "CHARLOTTE",
    state: "NC",
    country: "US",
    unitNumber: "2065",
  },
  CLT5: {
    name: "CLT5 - SortCenter (Concord, NC)",
    addressLine1: "1745 Derita Rd",
    addressLine2: "",
    zipCode: "28027",
    city: "Concord",
    state: "NC",
    country: "US",
    unitNumber: "1806",
  },
  CLT9: {
    name: "CLT9 - Sort Center (Charlotte, NC)",
    addressLine1: "2206 BELTWAY BLVD",
    addressLine2: "",
    zipCode: "28214",
    city: "CHARLOTTE",
    state: "NC",
    country: "US",
    unitNumber: "3G09",
  },
  CMH1: {
    name: "CMH1 - Sortable FC (Columbus, OH)",
    addressLine1: "11999 National Road SW",
    addressLine2: "",
    zipCode: "43018",
    city: "Etna",
    state: "OH",
    country: "US",
    unitNumber: "1827",
  },
  CMH2: {
    name: "CMH2 - NonSort FC (Obetz, OH)",
    addressLine1: "6050 Gateway Court",
    addressLine2: "",
    zipCode: "43125",
    city: "Groveport",
    state: "OH",
    country: "US",
    unitNumber: "1800",
  },
  CMH3: {
    name: "CMH3 - Sortable FC TNS (Monroe, OH)",
    addressLine1: "700 GATEWAY BLVD",
    addressLine2: "",
    zipCode: "45050",
    city: "MONROE",
    state: "OH",
    country: "US",
    unitNumber: "2534",
  },
  CMH4: {
    name: "CMH4 - FC (West Jefferson, OH)",
    addressLine1: "1550 W. Main Street",
    addressLine2: "",
    zipCode: "43162",
    city: "WEST JEFFERSON",
    state: "OH",
    country: "US",
    unitNumber: "2077",
  },
  CMH5: {
    name: "CMH5 - Sort Center (West Jefferson, OH)",
    addressLine1: "6400 State Route 29",
    addressLine2: "",
    zipCode: "43162",
    city: "WEST JEFFERSON",
    state: "OH",
    country: "US",
    unitNumber: "3G25",
  },
  CMH7: {
    name: "CMH7 - FC Sortable (New Albany, OH)",
    addressLine1: "1245 BEECH RD SW",
    addressLine2: "",
    zipCode: "43054",
    city: "NEW ALBANY",
    state: "OH",
    country: "US",
    unitNumber: "1I79",
  },
  CNO5: {
    name: "CNO5 - Sort Center (Chino, CA)",
    addressLine1: "8601 MERRILL AVE",
    addressLine2: "",
    zipCode: "91710",
    city: "CHINO",
    state: "CA",
    country: "US",
    unitNumber: "3G10",
  },
  CNO9: {
    name: "CNO9 - Sort Center (City of Industry, CA)",
    addressLine1: "21971 Industry Way",
    addressLine2: "",
    zipCode: "91789",
    city: "City of Industry",
    state: "CA",
    country: "US",
    unitNumber: "3G92",
  },
  COS1: {
    name: "COS1 - MOD FC (Thornton, CO)",
    addressLine1: "14601 Grant St.",
    addressLine2: "",
    zipCode: "80023",
    city: "Thornton",
    state: "CO",
    country: "US",
    unitNumber: "7Z45",
  },
  COS5: {
    name: "COS5 - Sort Center (Colorado Springs, CO)",
    addressLine1: "4333 Integration Loop",
    addressLine2: "",
    zipCode: "80916",
    city: "COLORADO SPRINGS",
    state: "CO",
    country: "US",
    unitNumber: "3G69",
  },
  CRG1: {
    name: "CRG1 - FC (Jacksonville, FL)",
    addressLine1: "13450 WATERWORKS ST",
    addressLine2: "",
    zipCode: "32221",
    city: "JACKSONVILLE",
    state: "FL",
    country: "US",
    unitNumber: "3W76",
  },
  CSG1: {
    name: "CSG1 - FC Sortable (Moreland, GA)",
    addressLine1: "280 BRIDGEPORT PKWY",
    addressLine2: "",
    zipCode: "30259",
    city: "MORELAND",
    state: "GA",
    country: "US",
    unitNumber: "1I97",
  },
  CVG1: {
    name: "CVG1 - (Hebron, KY)",
    addressLine1: "1155 Worldwide Blvd.",
    addressLine2: "",
    zipCode: "41048",
    city: "Hebron",
    state: "KY",
    country: "US",
    unitNumber: "1254",
  },
  CVG19: {
    name: "CVG19 - Network Control Center (Erlanger, CA)",
    addressLine1: "77 Comair Blvd",
    addressLine2: "",
    zipCode: "41018",
    city: "Erlanger",
    state: "CA",
    country: "US",
    unitNumber: "5979",
  },
  CVG2: {
    name: "CVG2 - NonSort FC (Hebron, KY)",
    addressLine1: "1600 Worldwide Blvd.",
    addressLine2: "",
    zipCode: "41048",
    city: "Hebron",
    state: "KY",
    country: "US",
    unitNumber: "1255",
  },
  CVG3: {
    name: "CVG3 - (Hebron, KY)",
    addressLine1: "3680 Langley Dr.",
    addressLine2: "Suite 100 ",
    zipCode: "41048",
    city: "Hebron",
    state: "KY",
    country: "US",
    unitNumber: "1256",
  },
  CVG5: {
    name: "CVG5 - SortCenter (Hebron, KY)",
    addressLine1: "2285 Litton Lane",
    addressLine2: "",
    zipCode: "41048",
    city: "Hebron",
    state: "KY",
    country: "US",
    unitNumber: "1258",
  },
  CVG9: {
    name: "CVG9 - SortCenter (Hebron, KY)",
    addressLine1: "2305 Litton Ln",
    addressLine2: "",
    zipCode: "41048",
    city: "Hebron",
    state: "KY",
    country: "US",
    unitNumber: "1177",
  },
  DCA1: {
    name: "DCA1 - Sortable FC (Sparrows Point, MD)",
    addressLine1: "1700 SPARROWS POINT BLVD",
    addressLine2: "",
    zipCode: "21219",
    city: "Sparrows Point",
    state: "MD",
    country: "US",
    unitNumber: "2449",
  },
  DCA6: {
    name: "DCA6 - NonSort FC (Sparrows Point, MD)",
    addressLine1: "6001 BETHLEHEM BLVD",
    addressLine2: "",
    zipCode: "21219",
    city: "BALTIMORE",
    state: "MD",
    country: "US",
    unitNumber: "1S32",
  },
  DEN2: {
    name: "DEN2 - NonSort FC TNS (Aurora, CO)",
    addressLine1: "22205 East 19th Ave",
    addressLine2: "",
    zipCode: "80019",
    city: "Aurora",
    state: "CO",
    country: "US",
    unitNumber: "2423",
  },
  DEN3: {
    name: "DEN3 - Sortable FC AR (Thornton, CO)",
    addressLine1: "14601 Grant Street",
    addressLine2: "",
    zipCode: "80023",
    city: "Thornton",
    state: "CO",
    country: "US",
    unitNumber: "2443",
  },
  DEN4: {
    name: "DEN4 - FC (Colorado Springs, CO)",
    addressLine1: "4222 INTEGRATION LOOP",
    addressLine2: "",
    zipCode: "80916",
    city: "COLORADO SPRINGS",
    state: "CO",
    country: "US",
    unitNumber: "1030",
  },
  DEN5: {
    name: "DEN5 - SortCenter (Denver, CO)",
    addressLine1: "19799 E. 36th Drive",
    addressLine2: "",
    zipCode: "80011",
    city: "Aurora",
    state: "CO",
    country: "US",
    unitNumber: "1085",
  },
  DEN8: {
    name: "DEN8 - TNS FC (Aurora, CO)",
    addressLine1: "21000 E 13th Ave",
    addressLine2: "",
    zipCode: "80018",
    city: "AURORA",
    state: "CO",
    country: "US",
    unitNumber: "1Y66",
  },
  DET1: {
    name: "DET1 - NonSort FC TNS (Livonia, MI)",
    addressLine1: "39000 Amrhein Road",
    addressLine2: "",
    zipCode: "48150",
    city: "Livonia",
    state: "MI",
    country: "US",
    unitNumber: "2422",
  },
  DET2: {
    name: "DET2 - Sortable FC TNS (Shelby Charter Township, MI)",
    addressLine1: "50500 MOUND RD",
    addressLine2: "",
    zipCode: "48317",
    city: "SHELBY TOWNSHIP",
    state: "MI",
    country: "US",
    unitNumber: "2533",
  },
  DET3: {
    name: "DET3 - Sortable FC AR (Pontiac, MI)",
    addressLine1: "1200 FEATHERSTONE RD",
    addressLine2: "",
    zipCode: "48342",
    city: "PONTIAC",
    state: "MI",
    country: "US",
    unitNumber: "1N50",
  },
  DET6: {
    name: "DET6 - Sortable FC (Detroit, MI)",
    addressLine1: "20110 WOODWARD AVE",
    addressLine2: "",
    zipCode: "48203",
    city: "DETROIT",
    state: "MI",
    country: "US",
    unitNumber: "1I68",
  },
  DET7: {
    name: "DET7 - FC (Romulus, MI)",
    addressLine1: "33700 Prescott Street",
    addressLine2: "",
    zipCode: "48174",
    city: "ROMULUS",
    state: "MI",
    country: "US",
    unitNumber: "3W71",
  },
  DSM3: {
    name: "DSM3 - FC (Council Bluffs, IA)",
    addressLine1: "4500 S. 19th Street",
    addressLine2: "",
    zipCode: "51501",
    city: "Council Bluffs",
    state: "IA",
    country: "US",
    unitNumber: "2093",
  },
  DSM5: {
    name: "DSM5 - FC (Bondurant, IA)",
    addressLine1: "500 32nd Street SW",
    addressLine2: "",
    zipCode: "50035",
    city: "BONDURANT",
    state: "IA",
    country: "US",
    unitNumber: "1T86",
  },
  DSM9: {
    name: "DSM9 - Sort Center (Bondurant, IA)",
    addressLine1: "2300 Shiloh Rose Parkway SW",
    addressLine2: "",
    zipCode: "50035",
    city: "BONDURANT",
    state: "IA",
    country: "US",
    unitNumber: "3B57",
  },
  DTW1: {
    name: "DTW1 - Sortable FC ARS (Romulus, MI)",
    addressLine1: "32801 Ecorse Road",
    addressLine2: "",
    zipCode: "48174",
    city: "Romulus",
    state: "MI",
    country: "US",
    unitNumber: "2518",
  },
  DTW5: {
    name: "DTW5 - SortCenter (Brownstown, MI)",
    addressLine1: "19991 Brownstown Center Drive",
    addressLine2: " ",
    zipCode: "48192",
    city: "BROWNSTOWN",
    state: "MI",
    country: "US",
    unitNumber: "1818",
  },
  DTW8: {
    name: "DTW8 - Sort Center (Plymouth, MI)",
    addressLine1: "9075 N HAGGERTY RD",
    addressLine2: "",
    zipCode: "48170",
    city: "PLYMOUTH",
    state: "MI",
    country: "US",
    unitNumber: "3B74",
  },
  DTW9: {
    name: "DTW9 - Sort Center (Romulus, MI)",
    addressLine1: "18000 VINING RD",
    addressLine2: "",
    zipCode: "48164",
    city: "NEW BOSTON",
    state: "MI",
    country: "US",
    unitNumber: "3G72",
  },
  EUG5: {
    name: "EUG5 - Sort Center (Portland, OR)",
    addressLine1: "1001 N Schmeer Road",
    addressLine2: "",
    zipCode: "97217",
    city: "PORTLAND",
    state: "OR",
    country: "US",
    unitNumber: "3G94",
  },
  EWR4: {
    name: "EWR4 - Sortable FC (Robbinsville, NJ)",
    addressLine1: "50 New Canton Way",
    addressLine2: "",
    zipCode: "08691",
    city: "Robbinsville",
    state: "NJ",
    country: "US",
    unitNumber: "1569",
  },
  EWR5: {
    name: "EWR5 - SortCenter (Avenel, NJ)",
    addressLine1: "301 Blair Road",
    addressLine2: "",
    zipCode: "07001",
    city: "Avenel",
    state: "NJ",
    country: "US",
    unitNumber: "1558",
  },
  EWR7: {
    name: "EWR7 - ReLo FC (Avenel, NJ)",
    addressLine1: "275 Omar Ave",
    addressLine2: "",
    zipCode: "07001",
    city: "Avenel",
    state: "NJ",
    country: "US",
    unitNumber: "8J08",
  },
  EWR8: {
    name: "EWR8 - SortCenter (Newark, NJ)",
    addressLine1: "698 Route 46",
    addressLine2: "",
    zipCode: "07608",
    city: "Teterboro",
    state: "NJ",
    country: "US",
    unitNumber: "1043",
  },
  EWR9: {
    name: "EWR9 - Fresh FC (Carteret, NJ)",
    addressLine1: "8003 Industrial Parkway",
    addressLine2: "",
    zipCode: "07008",
    city: "Carteret",
    state: "NJ",
    country: "US",
    unitNumber: "1891",
  },
  FAT1: {
    name: "FAT1 - Sortable FC ARS (Fresno, CA)",
    addressLine1: "3575 S. Orange Ave.",
    addressLine2: "",
    zipCode: "93725",
    city: "Fresno",
    state: "CA",
    country: "US",
    unitNumber: "2441",
  },
  FAT2: {
    name: "FAT2 - Non Sortable FC TNS (Visalia, CA)",
    addressLine1: "3315 N KELSEY ST",
    addressLine2: "",
    zipCode: "93291",
    city: "VISALIA",
    state: "CA",
    country: "US",
    unitNumber: "1I36",
  },
  FAT5: {
    name: "FAT5 - Sort Center (Fresno, CA)",
    addressLine1: "3611 S. Northpointe Drive",
    addressLine2: "",
    zipCode: "93725",
    city: "FRESNO",
    state: "CA",
    country: "US",
    unitNumber: "3G26",
  },
  FLL1: {
    name: "FLL1 - Small Parts Miramar FC (Miramar, FL)",
    addressLine1: "15901 SW 29th Street",
    addressLine2: "Suite 201",
    zipCode: "33027",
    city: "Miramar",
    state: "FL",
    country: "US",
    unitNumber: "1111",
  },
  FLL3: {
    name: "FLL3 - Sortable FC ARS (Sunrise, FL)",
    addressLine1: "4588 Hiatus Road",
    addressLine2: "",
    zipCode: "33351",
    city: "Sunrise",
    state: "FL",
    country: "US",
    unitNumber: "1V62",
  },
  FOE1: {
    name: "FOE1 - Non Sortable FC TNS (Kansas City, KS)",
    addressLine1: "9400 Leavenworth Road",
    addressLine2: "",
    zipCode: "66109",
    city: "KANSAS CITY",
    state: "KS",
    country: "US",
    unitNumber: "1I55",
  },
  FSD1: {
    name: "FSD1 - FC Sortable (Sioux Falls, SD)",
    addressLine1: "6700 N Marion Rd",
    addressLine2: "",
    zipCode: "57107",
    city: "SIOUX FALLS",
    state: "SD",
    country: "US",
    unitNumber: "1I70",
  },
  FWA4: {
    name: "FWA4 - FC IXD (Fort Wayne, IN)",
    addressLine1: "9798 SMITH RD",
    addressLine2: "",
    zipCode: "46809",
    city: "FORT WAYNE",
    state: "IN",
    country: "US",
    unitNumber: "1I04",
  },
  FWA6: {
    name: "FWA6 - FC Sortable (Fort Wayne, IN)",
    addressLine1: "5510 FLAUGH RD",
    addressLine2: "",
    zipCode: "46818",
    city: "FORT WAYNE",
    state: "IN",
    country: "US",
    unitNumber: "2W95",
  },
  GRR1: {
    name: "GRR1 - FC (Caledonia, MI)",
    addressLine1: "4500 68th Street SE.",
    addressLine2: "",
    zipCode: "49316",
    city: "CALEDONIA",
    state: "MI",
    country: "US",
    unitNumber: "2073",
  },
  GRR5: {
    name: "GRR5 - Sort Center (Caledonia, MI)",
    addressLine1: "4495 68th St. SE",
    addressLine2: "",
    zipCode: "49316",
    city: "Caledonia",
    state: "MI",
    country: "US",
    unitNumber: "3G79",
  },
  GSO1: {
    name: "GSO1 - NonSort FC (Kernersville, NC)",
    addressLine1: "1656 OLD GREENSBORO RD",
    addressLine2: "",
    zipCode: "27284",
    city: "KERNERSVILLE",
    state: "NC",
    country: "US",
    unitNumber: "2135",
  },
  GSP1: {
    name: "GSP1 - NonSort FC (Spartanburg, SC)",
    addressLine1: "402 John Dodd Rd",
    addressLine2: "",
    zipCode: "29303",
    city: "Spartanburg",
    state: "SC",
    country: "US",
    unitNumber: "1444",
  },
  GYR1: {
    name: "GYR1 - FC (Goodyear, AZ)",
    addressLine1: "605 S BULLARD AVE",
    addressLine2: "",
    zipCode: "85338",
    city: "GOODYEAR",
    state: "AZ",
    country: "US",
    unitNumber: "1W21",
  },
  GYR2: {
    name: "GYR2 - FC IXD (Goodyear, AZ)",
    addressLine1: "17341 W Minnezona Ave",
    addressLine2: "",
    zipCode: "85395",
    city: "GOODYEAR",
    state: "AZ",
    country: "US",
    unitNumber: "1W22",
  },
  GYR3: {
    name: "GYR3 - FC IXD (Phoenix, AZ)",
    addressLine1: "8181 W ROOSEVELT ST",
    addressLine2: "",
    zipCode: "85043",
    city: "PHOENIX",
    state: "AZ",
    country: "US",
    unitNumber: "1V73",
  },
  GYR4: {
    name: "GYR4 - MbA (Phoenix, AZ)",
    addressLine1: "10205 W Roosevelt",
    addressLine2: "",
    zipCode: "85323",
    city: "AVONDALE",
    state: "AZ",
    country: "US",
    unitNumber: "3A37",
  },
  HCA6: {
    name: "HCA6 - ReLo NonSort FC (Las Vegas, NV)",
    addressLine1: "2821 MARION DR",
    addressLine2: "",
    zipCode: "89115",
    city: "LAS VEGAS",
    state: "NV",
    country: "US",
    unitNumber: "7698",
  },
  HEA1: {
    name: "HEA1 - Supplemental FC (Hagerstown, MD)",
    addressLine1: "811 WESEL BLVD",
    addressLine2: "",
    zipCode: "21740",
    city: "HAGERSTOWN",
    state: "MD",
    country: "US",
    unitNumber: "3H95",
  },
  HEA2: {
    name: "HEA2 - Supplemental FC (Breinigsville, PA)",
    addressLine1: "650 BOULDER DR",
    addressLine2: "",
    zipCode: "18031",
    city: "BREINIGSVILLE",
    state: "PA",
    country: "US",
    unitNumber: "3H92",
  },
  HFD5: {
    name: "HFD5 - Sort Center (Manchester, CT)",
    addressLine1: "1339 TOLLAND TPKE",
    addressLine2: "",
    zipCode: "06042",
    city: "MANCHESTER",
    state: "CT",
    country: "US",
    unitNumber: "3G71",
  },
  HGR5: {
    name: "HGR5 - FC Kariba (Shippensburg, PA)",
    addressLine1: "1480 UNITED DR",
    addressLine2: "",
    zipCode: "17257",
    city: "SHIPPENSBURG",
    state: "PA",
    country: "US",
    unitNumber: "8A34",
  },
  HIO2: {
    name: "HIO2 - MOD (Troutdale, OR)",
    addressLine1: "1250 NW Swigert Way",
    addressLine2: "",
    zipCode: "97060",
    city: "Troutdale",
    state: "OR",
    country: "US",
    unitNumber: "5T11",
  },
  HIO9: {
    name: "HIO9 - FC (Hillsboro, OR)",
    addressLine1: "23677 NM Huffman Street",
    addressLine2: "",
    zipCode: "97124",
    city: "Hillsboro",
    state: "OR",
    country: "US",
    unitNumber: "8J61",
  },
  HMW4: {
    name: "HMW4 - Supplemental FC (Council Bluffs, IA)",
    addressLine1: "3860 S. 24th Street",
    addressLine2: "",
    zipCode: "51501",
    city: "Council Bluffs",
    state: "IA",
    country: "US",
    unitNumber: "3H96",
  },
  HNC3: {
    name: "HNC3 - Supplemental FC (Caledonia, MI)",
    addressLine1: "6665 PATTERSON AVE SE",
    addressLine2: "",
    zipCode: "49316",
    city: "CALEDONIA",
    state: "MI",
    country: "US",
    unitNumber: "5M16",
  },
  HNW1: {
    name: "HNW1 - Supplemental FC (Compton, CA)",
    addressLine1: "3015 E ANA ST",
    addressLine2: "",
    zipCode: "90221",
    city: "COMPTON",
    state: "CA",
    country: "US",
    unitNumber: "3W90",
  },
  HSF6: {
    name: "HSF6 - FC Kariba (Sacramento, CA)",
    addressLine1: "1401 GRIFFITH ST",
    addressLine2: "",
    zipCode: "94124",
    city: "SAN FRANCISCO",
    state: "CA",
    country: "US",
    unitNumber: "5M19",
  },
  HSV1: {
    name: "HSV1 - Non Sortable FC TNS (Madison, AL)",
    addressLine1: "7817 Greenbrier Road",
    addressLine2: "",
    zipCode: "35756",
    city: "MADISON",
    state: "AL",
    country: "US",
    unitNumber: "1Y91",
  },
  HWE2: {
    name: "HWE2 - Supplemental FC (Sacramento, CA)",
    addressLine1: "8035 METRO AIR PKWY",
    addressLine2: "",
    zipCode: "95837",
    city: "SACRAMENTO",
    state: "CA",
    country: "US",
    unitNumber: "3H98",
  },
  ICT2: {
    name: "ICT2 - Non Sortable FC TNS (Park City, KS)",
    addressLine1: "7130 N BROADWAY AVE",
    addressLine2: "",
    zipCode: "67219",
    city: "PARK CITY",
    state: "KS",
    country: "US",
    unitNumber: "1I56",
  },
  IGQ1: {
    name: "IGQ1- Sortable FC AR (Markham, IL)",
    addressLine1: "2201 W 159TH ST",
    addressLine2: "",
    zipCode: "60428",
    city: "HARVEY",
    state: "IL",
    country: "US",
    unitNumber: "3K03",
  },
  IGQ2: {
    name: "IGQ2 - FC TNS (University Park, IL)",
    addressLine1: "23257 S. Central Avenue",
    addressLine2: "",
    zipCode: "60484",
    city: "University Park",
    state: "IL",
    country: "US",
    unitNumber: "1I93",
  },
  IGQ5: {
    name: "IGQ5 - Sort Center (Chicago, IL)",
    addressLine1: "3140 E. 122nd Street",
    addressLine2: "",
    zipCode: "60617",
    city: "CHICAGO",
    state: "IL",
    country: "US",
    unitNumber: "3G85",
  },
  IGQ9: {
    name: "IGQ9 - Sort Center - (Dekalb, IL)",
    addressLine1: "1401 E Gurler Rd",
    addressLine2: "",
    zipCode: "60115",
    city: "Dekalb",
    state: "IL",
    country: "US",
    unitNumber: "3M39",
  },
  ILG1: {
    name: "ILG1 - NonSort FC TNS (New Castle, DE)",
    addressLine1: "780 S. DuPont Highway",
    addressLine2: "",
    zipCode: "19720",
    city: "NEW CASTLE",
    state: "DE",
    country: "US",
    unitNumber: "1I73",
  },
  IND1: {
    name: "IND1 - Sortable FC (Whitestown, IN)",
    addressLine1: "4255 Anson Blvd",
    addressLine2: "",
    zipCode: "46075",
    city: "Whitestown",
    state: "IN",
    country: "US",
    unitNumber: "1413",
  },
  IND2: {
    name: "IND2 - NonSort FC (Plainfield, IN)",
    addressLine1: "715 Airtech Pkwy",
    addressLine2: "",
    zipCode: "46168",
    city: "Plainfield",
    state: "IN",
    country: "US",
    unitNumber: "1414",
  },
  IND3: {
    name: "IND3 - Small Parts/BISS (Plainfield, IN)",
    addressLine1: "715 Airtech Parkway",
    addressLine2: "Suite 195",
    zipCode: "46168",
    city: "Plainfield",
    state: "IN",
    country: "US",
    unitNumber: "1415",
  },
  IND4: {
    name: "IND4 - Sortable FC (Indianapolis, IN)",
    addressLine1: "710 South Girls School Road",
    addressLine2: "",
    zipCode: "46231",
    city: "Indianapolis",
    state: "IN",
    country: "US",
    unitNumber: "1429",
  },
  IND5: {
    name: "IND5 - NonSort FC (Plainfield, IN)",
    addressLine1: "800 Perry Road",
    addressLine2: "",
    zipCode: "46168",
    city: "Plainfield",
    state: "IN",
    country: "US",
    unitNumber: "1435",
  },
  IND7: {
    name: "IND7 - Supplemental FC (Indianapolis, IN)",
    addressLine1: "9101 Orly Drive",
    addressLine2: "",
    zipCode: "46241",
    city: "Indianapolis",
    state: "IN",
    country: "US",
    unitNumber: "1498",
  },
  IND8: {
    name: "IND8 - FC (Indianapolis, IN)",
    addressLine1: "7760 W. Morris Street",
    addressLine2: "",
    zipCode: "46231",
    city: "INDIANAPOLIS",
    state: "IN",
    country: "US",
    unitNumber: "2098",
  },
  IND9: {
    name: "IND9 - FC IXD (Greenwood, IN)",
    addressLine1: "1151 S GRAHAM RD",
    addressLine2: "",
    zipCode: "46143",
    city: "GREENWOOD",
    state: "IN",
    country: "US",
    unitNumber: "2119",
  },
  JAN1: {
    name: "JAN1 - FC Sortable (Canton, MS)",
    addressLine1: "219 MADISON COUNTY PKWY",
    addressLine2: "",
    zipCode: "39046",
    city: "CANTON",
    state: "MS",
    country: "US",
    unitNumber: "1I58",
  },
  JAX2: {
    name: "JAX2 - Sortable FC (Jacksonville, FL)",
    addressLine1: "12900 Pecan Park Road",
    addressLine2: "",
    zipCode: "32218",
    city: "Jacksonville",
    state: "FL",
    country: "US",
    unitNumber: "2407",
  },
  JAX3: {
    name: "JAX3 - NonSort FC TNS (Jacksonville, FL)",
    addressLine1: "13333 103rd Street",
    addressLine2: "",
    zipCode: "32221",
    city: "Jacksonville",
    state: "FL",
    country: "US",
    unitNumber: "2436",
  },
  JAX5: {
    name: "JAX5 - SortCenter (Jacksonville, FL)",
    addressLine1: "4948 Bulls Bay Hwy",
    addressLine2: "",
    zipCode: "32219",
    city: "Jacksonville",
    state: "FL",
    country: "US",
    unitNumber: "1161",
  },
  JAX7: {
    name: "JAX7 - FC Sortable (Jacksonville, FL)",
    addressLine1: "10501 Cold Storage Rd",
    addressLine2: "",
    zipCode: "32218",
    city: "JACKSONVILLE",
    state: "FL",
    country: "US",
    unitNumber: "1I74",
  },
  JAX9: {
    name: "JAX9 - Sort Center (Jacksonville, FL)",
    addressLine1: "13450 WATERWORKS ST",
    addressLine2: "",
    zipCode: "32221",
    city: "JACKSONVILLE",
    state: "FL",
    country: "US",
    unitNumber: "3G19",
  },
  JFK7: {
    name: "JFK7 - FC Sortable (Staten Island, NY)",
    addressLine1: "7 W 34th Street",
    addressLine2: "",
    zipCode: "10001",
    city: "New York",
    state: "NY",
    country: "US",
    unitNumber: "1I78",
  },
  JFK8: {
    name: "JFK8 - Sortable FC ARS (Staten Island, NY)",
    addressLine1: "546 GULF AVE",
    addressLine2: "",
    zipCode: "10314",
    city: "STATEN ISLAND",
    state: "NY",
    country: "US",
    unitNumber: "2523",
  },
  JHW1: {
    name: "JHW1 - FC (Colorado Springs, CO)",
    addressLine1: "4333 INTEGRATION LOOP",
    addressLine2: "",
    zipCode: "80916",
    city: "COLORADO SPRINGS",
    state: "CO",
    country: "US",
    unitNumber: "3W68",
  },
  JVL1: {
    name: "JVL1 - NonSort FC (Beloit, WI)",
    addressLine1: "1255 Gateway Blvd",
    addressLine2: "",
    zipCode: "53511",
    city: "Beloit",
    state: "WI",
    country: "US",
    unitNumber: "1V59",
  },
  KATL: {
    name: "KATL-AirGW (Atlanta, GA)",
    addressLine1: "Cargo Building A, 4300 ASR Road",
    addressLine2: "",
    zipCode: "30320",
    city: "ATLANTA",
    state: "GA",
    country: "US",
    unitNumber: "1S43",
  },
  KBDL: {
    name: "KBDL-AirGW (Hartford, CT)",
    addressLine1: "Air Cargo East 100 Cargo Road Bradley International Airport",
    addressLine2: "",
    zipCode: "06096",
    city: "Windsor Locks",
    state: "CT",
    country: "US",
    unitNumber: "5961",
  },
  KBFM: {
    name: "KBFM-AirGW (Mobile, AL)",
    addressLine1: "2455 Michigan Ave",
    addressLine2: "",
    zipCode: "36615",
    city: "MOBILE",
    state: "AL",
    country: "US",
    unitNumber: "9Z96",
  },
  KBOI: {
    name: "KBOI-AirGW (Boise, ID)",
    addressLine1: "1850 Gowen Road",
    addressLine2: "",
    zipCode: "83716",
    city: "BOISE",
    state: "ID",
    country: "US",
    unitNumber: "9Z66",
  },
  KBWI: {
    name: "KBWI-AirGW-BB (Baltimore, MD)",
    addressLine1: "7062 Elm Rd.",
    addressLine2: "",
    zipCode: "21240",
    city: "Baltimore",
    state: "MD",
    country: "US",
    unitNumber: "1K93",
  },
  KBWI1: {
    name: "KBWI1 - BWI Gateway (Hanover, MD)",
    addressLine1: "27350 Mathison Way",
    addressLine2: "",
    zipCode: "21240",
    city: "Baltimore",
    state: "MD",
    country: "US",
    unitNumber: "5981",
  },
  KCVG: {
    name: "KCVG-AirGW-BB (Erlanger, KY)",
    addressLine1: "236 Wendel H Ford Blvd",
    addressLine2: "",
    zipCode: "41018",
    city: "ERLANGER",
    state: "KY",
    country: "US",
    unitNumber: "1B69",
  },
  KDSM: {
    name: "KDSM - Air Gateway (Des Moines, IA)",
    addressLine1: "5800 Fleur Dr.",
    addressLine2: "",
    zipCode: "50321",
    city: "DES MOINES",
    state: "IA",
    country: "US",
    unitNumber: "9Z75",
  },
  KHUB: {
    name: "KHUB - CVG Gateway 3P (Erlanger, KY)",
    addressLine1: "236 Wendel H Ford Blvd",
    addressLine2: "",
    zipCode: "41018",
    city: "ERLANGER",
    state: "KY",
    country: "US",
    unitNumber: "5999",
  },
  KICT: {
    name: "KICT-AirGW (Wichita, KS)",
    addressLine1: "1935 S. Air Cargo Rd",
    addressLine2: "Ste 700",
    zipCode: "67209",
    city: "WICHITA",
    state: "KS",
    country: "US",
    unitNumber: "9Z68",
  },
  KILN: {
    name: "KILN-AirGW-BB (Wilmington,OH)",
    addressLine1: "325 Ruane Drive",
    addressLine2: "",
    zipCode: "45177",
    city: "Wilmington",
    state: "OH",
    country: "US",
    unitNumber: "5991",
  },
  KJFK: {
    name: "KJFK-AirGW (Jamaica, NY)",
    addressLine1: "23 N Service Rd",
    addressLine2: "",
    zipCode: "11430",
    city: "JAMAICA",
    state: "NY",
    country: "US",
    unitNumber: "3A05",
  },
  KLAL: {
    name: "KLAL-AirGW (Lakeland, FL)",
    addressLine1: "4145 KIDRON RD.",
    addressLine2: "",
    zipCode: "33811",
    city: "LAKELAND",
    state: "FL",
    country: "US",
    unitNumber: "6530",
  },
  KLAS: {
    name: "KLAS-AirGW (Las Vegas, NV)",
    addressLine1: "1855 Joel Aller Drive",
    addressLine2: "Suite 101",
    zipCode: "89119",
    city: "LAS VEGAS",
    state: "NV",
    country: "US",
    unitNumber: "9Z67",
  },
  KLAX: {
    name: "KLAX-AirGW (Los Angeles, CA)",
    addressLine1: "6555 W Imperial Hwy",
    addressLine2: "",
    zipCode: "90045",
    city: "Los Angeles",
    state: "CA",
    country: "US",
    unitNumber: "3A85",
  },
  KMCI: {
    name: "KMCI-AirGW (Kansas City, MO)",
    addressLine1: "682 Mexico City Avenue",
    addressLine2: "Suite 728",
    zipCode: "64153",
    city: "KANSAS CITY",
    state: "MO",
    country: "US",
    unitNumber: "9Z91",
  },
  KMHT: {
    name: "KMHT-AirGW (Manchester, NH)",
    addressLine1: "7 Green Drive",
    addressLine2: "Suite 100",
    zipCode: "03103",
    city: "Manchester",
    state: "NH",
    country: "US",
    unitNumber: "9Z65",
  },
  KMIA: {
    name: "KMIA-AirGW (Miami, FL)",
    addressLine1: "6185 NW 18th St ",
    addressLine2: "Bldg 716A",
    zipCode: "33126",
    city: "Miami",
    state: "FL",
    country: "US",
    unitNumber: "5987",
  },
  KOMA: {
    name: "KOMA-AirGW (Omaha, NE)",
    addressLine1: "1819 Fort Ct",
    addressLine2: "",
    zipCode: "68110",
    city: "OMAHA",
    state: "NE",
    country: "US",
    unitNumber: "9Z74",
  },
  KORD: {
    name: "KORD-AirGW (Chicago, IL)",
    addressLine1: "10510 W ZEMKE CIR",
    addressLine2: "",
    zipCode: "60666",
    city: "CHICAGO",
    state: "IL",
    country: "US",
    unitNumber: "3A83",
  },
  KPDX: {
    name: "KPDX-AirGW (Portland, OR)",
    addressLine1: "7425 NE Airtrans Way",
    addressLine2: "Unit 100",
    zipCode: "97218",
    city: "Portland",
    state: "OR",
    country: "US",
    unitNumber: "5988",
  },
  KRB1: {
    name: "KRB1 - Kariba (San Bernardino, CA)",
    addressLine1: "555 E ORANGE SHOW RD",
    addressLine2: "",
    zipCode: "92408",
    city: "SAN BERNARDINO",
    state: "CA",
    country: "US",
    unitNumber: "9J05",
  },
  KRB2: {
    name: "KRB2 - FC Speciality (Prince George, VA)",
    addressLine1: "7000 HARDWARE DR",
    addressLine2: "",
    zipCode: "23875",
    city: "PRINCE GEORGE",
    state: "VA",
    country: "US",
    unitNumber: "1I94",
  },
  KRB3: {
    name: "KRB3 - Kariba (Phoenix, AZ)",
    addressLine1: "8181 W ROOSEVELT ST",
    addressLine2: "",
    zipCode: "85043",
    city: "PHOENIX",
    state: "AZ",
    country: "US",
    unitNumber: "4I19",
  },
  KRB4: {
    name: "KRB4 - FC IXD (Perris, CA)",
    addressLine1: "4501 PATTERSON AVE",
    addressLine2: "",
    zipCode: "92571",
    city: "PERRIS",
    state: "CA",
    country: "US",
    unitNumber: "1I51",
  },
  KRB5: {
    name: "KRB5 - Kariba (North East, MD)",
    addressLine1: "600 PRINCIPIO PKWY W",
    addressLine2: "",
    zipCode: "21901",
    city: "NORTH EAST",
    state: "MD",
    country: "US",
    unitNumber: "4I34",
  },
  KRB6: {
    name: "KRB6 - FC Kariba (Aurora, IL)",
    addressLine1: "4200 FERRY RD",
    addressLine2: "",
    zipCode: "60502",
    city: "AURORA",
    state: "IL",
    country: "US",
    unitNumber: "2447",
  },
  KRB7: {
    name: "KRB7 - FC Kariba (Beaumont, CA)",
    addressLine1: "36900 W 4th St",
    addressLine2: "",
    zipCode: "92223",
    city: "BEAUMONT",
    state: "CA",
    country: "US",
    unitNumber: "7Z73",
  },
  KRB9: {
    name: "KRB9 - FC Kariba (Mesa, AZ)",
    addressLine1: "8560 E ELLIOT RD",
    addressLine2: "",
    zipCode: "85212",
    city: "MESA",
    state: "AZ",
    country: "US",
    unitNumber: "7Z13",
  },
  KRFD: {
    name: "KRFD-AirGW-BB (Rockford, IL)",
    addressLine1: "5824 Kishwaukee",
    addressLine2: "",
    zipCode: "61109",
    city: "Rockford",
    state: "IL",
    country: "US",
    unitNumber: "5998",
  },
  KRIC: {
    name: "KRIC-AirGW (Richmond, VA)",
    addressLine1: "5455 FOX RD",
    addressLine2: "",
    zipCode: "23250",
    city: "RICHMOND",
    state: "VA",
    country: "US",
    unitNumber: "3A88",
  },
  KRIV: {
    name: "KRIV-AirGW-BB (Riverside, CA)",
    addressLine1: "17101 HEACOCK ST",
    addressLine2: "STE 101",
    zipCode: "92551",
    city: "MORENO VALLEY",
    state: "CA",
    country: "US",
    unitNumber: "5960",
  },
  KSBD: {
    name: "KSBD-AirGW-BB (San Bernardino, CA)",
    addressLine1: "2535 E 3rd Street",
    addressLine2: "",
    zipCode: "92408",
    city: "SAN BERNARDINO",
    state: "CA",
    country: "US",
    unitNumber: "8039",
  },
  KSFO: {
    name: "KSFO-AirGW (San Francisco, CA)",
    addressLine1: "710 N McDonnell Rd,",
    addressLine2: "",
    zipCode: "94128",
    city: "San Francisco",
    state: "CA",
    country: "US",
    unitNumber: "3A84",
  },
  KSTL: {
    name: "KSTL-AirGW (St. Louis, MO)",
    addressLine1: "6111 James S. McDonnell Blvd",
    addressLine2: "",
    zipCode: "63134",
    city: "Berkeley",
    state: "MO",
    country: "US",
    unitNumber: "1S44",
  },
  LAL4: {
    name: "LAL4 - FC (Fort Myers, FL)",
    addressLine1: "8250 LOGISTICS DR",
    addressLine2: "",
    zipCode: "33912",
    city: "FORT MYERS",
    state: "FL",
    country: "US",
    unitNumber: "3W78",
  },
  LAS1: {
    name: "LAS1 - FC IXD (Henderson, NV)",
    addressLine1: "12300 Bermuda Road",
    addressLine2: "",
    zipCode: "89044",
    city: "HENDERSON",
    state: "NV",
    country: "US",
    unitNumber: "1B66",
  },
  LAS2: {
    name: "LAS2 - FDFC (Las Vegas, NV)",
    addressLine1: "3837 Bay Lake Trail",
    addressLine2: "Suite 111",
    zipCode: "89030",
    city: "North Las Vegas",
    state: "NV",
    country: "US",
    unitNumber: "1461",
  },
  LAS5: {
    name: "LAS5 - SortCenter (Las Vegas, NV)",
    addressLine1: "4410 Nexus Way",
    addressLine2: "",
    zipCode: "89115",
    city: "Las Vegas",
    state: "NV",
    country: "US",
    unitNumber: "1162",
  },
  LAS6: {
    name: "LAS6 - NonSort FC TNS (North Las Vegas, NV)",
    addressLine1: "4550 Nexus Way",
    addressLine2: "",
    zipCode: "89115",
    city: "Las Vegas",
    state: "NV",
    country: "US",
    unitNumber: "2427",
  },
  LAS7: {
    name: "LAS7 - FC (N Las Vegas, NV)",
    addressLine1: "6001 E TROPICAL PKWY",
    addressLine2: "",
    zipCode: "89115",
    city: "LAS VEGAS",
    state: "NV",
    country: "US",
    unitNumber: "2062",
  },
  LAS8: {
    name: "LAS8 - MOD (Las Vegas, NV)",
    addressLine1: "5801 N. Nicco Way",
    addressLine2: "",
    zipCode: "89115",
    city: "Las Vegas",
    state: "NV",
    country: "US",
    unitNumber: "1I88",
  },
  LAS9: {
    name: "LAS9 - MbA (Las Vegas, NV)",
    addressLine1: "5801 N. Nicco Way",
    addressLine2: "",
    zipCode: "89115",
    city: "LAS VEGAS",
    state: "NV",
    country: "US",
    unitNumber: "3A40",
  },
  LAX5: {
    name: "LAX5 - SortCenter (Los Angeles, CA)",
    addressLine1: "6400 Valley View Street",
    addressLine2: "",
    zipCode: "90620",
    city: "Buena Park",
    state: "CA",
    country: "US",
    unitNumber: "1156",
  },
  LAX9: {
    name: "LAX9 - FC IXD (Fontana, CA)",
    addressLine1: "11263 Oleander Ave",
    addressLine2: "",
    zipCode: "92337",
    city: "FONTANA",
    state: "CA",
    country: "US",
    unitNumber: "2078",
  },
  LDJ5: {
    name: "LDJ5 - Sort Center (Staten Island, NY)",
    addressLine1: "626 GULF AVE",
    addressLine2: "",
    zipCode: "10314",
    city: "STATEN ISLAND",
    state: "NY",
    country: "US",
    unitNumber: "3G30",
  },
  LEX1: {
    name: "LEX1 - Sortable FC (Lexington, KY)",
    addressLine1: "1850 Mercer Rd.",
    addressLine2: "",
    zipCode: "40511",
    city: "Lexington",
    state: "KY",
    country: "US",
    unitNumber: "1250",
  },
  LEX2: {
    name: "LEX2 - Fulfillment Center (Lexington, KY)",
    addressLine1: "172 Trade St",
    addressLine2: "",
    zipCode: "40511",
    city: "Lexington",
    state: "KY",
    country: "US",
    unitNumber: "1251",
  },
  LEX5: {
    name: "LEX5 - MbA (Erlanger, KY)",
    addressLine1: "4600 OLYMPIC BLVD",
    addressLine2: "",
    zipCode: "41018",
    city: "ERLANGER",
    state: "KY",
    country: "US",
    unitNumber: "1893",
  },
  LGA5: {
    name: "LGA5 - Sort Center (Edison, NJ)",
    addressLine1: "2205 STATE ROUTE 27",
    addressLine2: "",
    zipCode: "08817",
    city: "EDISON",
    state: "NJ",
    country: "US",
    unitNumber: "3B50",
  },
  LGA7: {
    name: "LGA7 - NonSort FC DISABLED (Carteret, NJ)",
    addressLine1: "380 Middlesex Avenue",
    addressLine2: "",
    zipCode: "07008",
    city: "Carteret",
    state: "NJ",
    country: "US",
    unitNumber: "1828",
  },
  LGA9: {
    name: "LGA9 - Sortable FC ARS (Edison, NJ)",
    addressLine1: "2170 Route 27",
    addressLine2: "",
    zipCode: "08817",
    city: "Edison",
    state: "NJ",
    country: "US",
    unitNumber: "2417",
  },
  LGB3: {
    name: "LGB3 - Sortable FC ARS (Eastvale, CA)",
    addressLine1: "4950 Goodman Way",
    addressLine2: "",
    zipCode: "91752",
    city: "Eastvale",
    state: "CA",
    country: "US",
    unitNumber: "2416",
  },
  LGB4: {
    name: "LGB4 - NonSort FC TNS (Redlands, CA)",
    addressLine1: "27517 Pioneer Avenue",
    addressLine2: "",
    zipCode: "92374",
    city: "Redlands",
    state: "CA",
    country: "US",
    unitNumber: "2418",
  },
  LGB5: {
    name: "LGB5 - Sort Center (San Bernardino, CA)",
    addressLine1: "555 E ORANGE SHOW RD",
    addressLine2: "",
    zipCode: "92408",
    city: "SAN BERNARDINO",
    state: "CA",
    country: "US",
    unitNumber: "1851",
  },
  LGB6: {
    name: "LGB6 - Sortable FC TVH (Riverside, CA)",
    addressLine1: "20901 Krameria Ave",
    addressLine2: "",
    zipCode: "92518",
    city: "Riverside",
    state: "CA",
    country: "US",
    unitNumber: "2429",
  },
  LGB7: {
    name: "LGB7 - Sortable FC ARS (Rialto, CA)",
    addressLine1: "1660 N. Linden Avenue",
    addressLine2: "",
    zipCode: "92376",
    city: "Rialto",
    state: "CA",
    country: "US",
    unitNumber: "2438",
  },
  LGB8: {
    name: "LGB8 - Sortable FC IXD (Rialto, CA)",
    addressLine1: "1568 N Linden Ave",
    addressLine2: "",
    zipCode: "92376",
    city: "Rialto",
    state: "CA",
    country: "US",
    unitNumber: "2434",
  },
  LIT1: {
    name: "LIT1 - Sortable FC ARS (Little Rock, AR)",
    addressLine1: "7001 ZEUBER RD",
    addressLine2: "",
    zipCode: "72206",
    city: "LITTLE ROCK",
    state: "AR",
    country: "US",
    unitNumber: "1V56",
  },
  LIT2: {
    name: "LIT2 - FC TNS (Little Rock, AR)",
    addressLine1: "13001 HIGHWAY 70",
    addressLine2: "",
    zipCode: "72117",
    city: "NORTH LITTLE ROCK",
    state: "AR",
    country: "US",
    unitNumber: "1I14",
  },
  LPR5: {
    name: "LPR5 - Sort Center (Valley View, OH)",
    addressLine1: "5585 CANAL RD",
    addressLine2: "",
    zipCode: "44125",
    city: "VALLEY VIEW",
    state: "OH",
    country: "US",
    unitNumber: "3O65",
  },
  LUK2: {
    name: "LUK2 - FC Sortable (Vandalia, OH)",
    addressLine1: "10791 DOG LEG RD",
    addressLine2: "",
    zipCode: "45377",
    city: "VANDALIA",
    state: "OH",
    country: "US",
    unitNumber: "2W72",
  },
  LUK5: {
    name: "LUK5 - Sort Center DISABLED (Erlanger, KY)",
    addressLine1: "660 ERLANGER RD",
    addressLine2: "",
    zipCode: "41018",
    city: "ERLANGER",
    state: "KY",
    country: "US",
    unitNumber: "3G06",
  },
  LUK7: {
    name: "LUK7 - ReLo FC (Shepherdsville, KY)",
    addressLine1: "649 OMEGA PKWY",
    addressLine2: "",
    zipCode: "40165",
    city: "SHEPHERDSVILLE",
    state: "KY",
    country: "US",
    unitNumber: "1Y65",
  },
  MCE1: {
    name: "MCE1 - Non Sortable FC TNS (Turlock, CA)",
    addressLine1: "3200 Fulkerth Road",
    addressLine2: "",
    zipCode: "95380",
    city: "TURLOCK",
    state: "CA",
    country: "US",
    unitNumber: "1Y21",
  },
  MCI5: {
    name: "MCI5 - SortCenter (Lenexa, KS)",
    addressLine1: "16851 West 113th Street",
    addressLine2: "",
    zipCode: "66219",
    city: "Lenexa",
    state: "KS",
    country: "US",
    unitNumber: "1814",
  },
  MCI7: {
    name: "MCI7 - ReLo FC (New Century, KS)",
    addressLine1: "27200 W157th St",
    addressLine2: "",
    zipCode: "66031",
    city: "New Century",
    state: "KS",
    country: "US",
    unitNumber: "8051",
  },
  MCI9: {
    name: "MCI9 - Sort Center (Liberty, MO)",
    addressLine1: "2299 South Withers Road",
    addressLine2: "",
    zipCode: "64068",
    city: "LIBERTY",
    state: "MO",
    country: "US",
    unitNumber: "3M38",
  },
  MCO1: {
    name: "MCO1 - Sortable FC ARS (Orlando, FL)",
    addressLine1: "12340 BOGGY CREEK RD",
    addressLine2: "",
    zipCode: "32824",
    city: "ORLANDO",
    state: "FL",
    country: "US",
    unitNumber: "2446",
  },
  MCO2: {
    name: "MCO2 - NonSort FC (Deltona, FL)",
    addressLine1: "2600 N Normandy Blvd",
    addressLine2: "",
    zipCode: "32725",
    city: "Deltona",
    state: "FL",
    country: "US",
    unitNumber: "8023",
  },
  MCO3: {
    name: "MCO3 - MOD (Orlando, FL)",
    addressLine1: "12340 Boggy Creek Rd",
    addressLine2: "",
    zipCode: "32824",
    city: "Orlando",
    state: "FL",
    country: "US",
    unitNumber: "2W97",
  },
  MCO4: {
    name: "MCO4 - MbA (Davenport, FL)",
    addressLine1: "2314 WAVERLY BARN RD",
    addressLine2: "STE 150",
    zipCode: "33897",
    city: "DAVENPORT",
    state: "FL",
    country: "US",
    unitNumber: "3A38",
  },
  MCO5: {
    name: "MCO5 - SortCenter (Davenport, FL)",
    addressLine1: "305 Deen Still Road",
    addressLine2: "",
    zipCode: "33897",
    city: "Davenport",
    state: "FL",
    country: "US",
    unitNumber: "1564",
  },
  MCO6: {
    name: "MCO6 - ReLo Sortable FC (Swedesboro, NJ)",
    addressLine1: "800 ARLINGTON BLVD",
    addressLine2: "",
    zipCode: "08085",
    city: "SWEDESBORO",
    state: "NJ",
    country: "US",
    unitNumber: "7741",
  },
  MCO9: {
    name: "MCO9 - Sort Center (Davenport, FL)",
    addressLine1: "2600 ACCESS RD NW",
    addressLine2: "",
    zipCode: "33897",
    city: "DAVENPORT",
    state: "FL",
    country: "US",
    unitNumber: "1825",
  },
  MDT1: {
    name: "MDT1- NonSort FC (Carlisle, PA)",
    addressLine1: "2 Ames Drive",
    addressLine2: "",
    zipCode: "17015",
    city: "Carlisle",
    state: "PA",
    country: "US",
    unitNumber: "1449",
  },
  MDT2: {
    name: "MDT2 - Sortable FC TNS (North East, MD)",
    addressLine1: "600 Principio Parkway West",
    addressLine2: "",
    zipCode: "21901",
    city: "North East",
    state: "MD",
    country: "US",
    unitNumber: "2448",
  },
  MDT4: {
    name: "MDT4 - TNS FC (York, PA)",
    addressLine1: "5125 Commerce Drive",
    addressLine2: "",
    zipCode: "17408",
    city: "YORK",
    state: "PA",
    country: "US",
    unitNumber: "7Z96",
  },
  MDT5: {
    name: "MDT5 - Sort Center (Lewisberry, PA)",
    addressLine1: "200 Goodman Drive",
    addressLine2: "",
    zipCode: "17339",
    city: "Lewisberry,",
    state: "PA",
    country: "US",
    unitNumber: "3G80",
  },
  MDT8: {
    name: "MDT8 - FC (Lewisberry, PA)",
    addressLine1: "200 Goodman Drive",
    addressLine2: "",
    zipCode: "17339",
    city: "LEWISBERRY",
    state: "PA",
    country: "US",
    unitNumber: "3W89",
  },
  MDT9: {
    name: "MDT9 - FC Kariba (Frailey, PA)",
    addressLine1: "251 WESTWOOD HILL",
    addressLine2: "",
    zipCode: "17981",
    city: "TREMONT",
    state: "PA",
    country: "US",
    unitNumber: "8A35",
  },
  MDW1: {
    name: "MDW1 - FDFC (Gary, IN)",
    addressLine1: "101 45th Avenue",
    addressLine2: "",
    zipCode: "46321",
    city: "Munster",
    state: "IN",
    country: "US",
    unitNumber: "1459",
  },
  MDW2: {
    name: "MDW2 - Sortable FC (Joliet, IL)",
    addressLine1: "250 Emerald Drive",
    addressLine2: "",
    zipCode: "60433",
    city: "Joliet",
    state: "IL",
    country: "US",
    unitNumber: "1889",
  },
  MDW4: {
    name: "MDW4 - Sortable FC (Joliet, IL)",
    addressLine1: "201 EMERALD DR",
    addressLine2: "",
    zipCode: "60433",
    city: "JOLIET",
    state: "IL",
    country: "US",
    unitNumber: "1847",
  },
  MDW5: {
    name: "MDW5 - SortCenter (Chicago, IL)",
    addressLine1: "16824 Enterprise Blvd",
    addressLine2: "",
    zipCode: "60441",
    city: "Crest Hill",
    state: "IL",
    country: "US",
    unitNumber: "1157",
  },
  MDW6: {
    name: "MDW6 - NonSort FC (Romeoville, IL)",
    addressLine1: "1125 W REMINGTON BLVD",
    addressLine2: "",
    zipCode: "60446",
    city: "ROMEOVILLE",
    state: "IL",
    country: "US",
    unitNumber: "2305",
  },
  MDW7: {
    name: "MDW7 - Sortable FC (Monee, IL)",
    addressLine1: "6605 Monee Manhattan Road",
    addressLine2: "",
    zipCode: "60449",
    city: "Monee",
    state: "IL",
    country: "US",
    unitNumber: "2405",
  },
  MDW9: {
    name: "MDW9 - NonSort FC TNS (Aurora, IL)",
    addressLine1: "2865 Duke Parkway",
    addressLine2: "",
    zipCode: "60502",
    city: "Aurora",
    state: "IL",
    country: "US",
    unitNumber: "2420",
  },
  MEM1: {
    name: "MEM1 - Sortable FC IXD (Memphis, TN)",
    addressLine1: "3292 E Holmes Rd",
    addressLine2: "",
    zipCode: "38118",
    city: "Memphis",
    state: "TN",
    country: "US",
    unitNumber: "2035",
  },
  MEM2: {
    name: "MEM2 - FC (Byhalia, MS)",
    addressLine1: "191 NORFOLK SOUTHERN WAY",
    addressLine2: "",
    zipCode: "38611",
    city: "BYHALIA",
    state: "MS",
    country: "US",
    unitNumber: "2120",
  },
  MEM3: {
    name: "MEM3 - Supplemental FC (Horn Lake, MS)",
    addressLine1: "1615 COMMERCE PKWY N",
    addressLine2: "",
    zipCode: "38637",
    city: "HORN LAKE",
    state: "MS",
    country: "US",
    unitNumber: "1I49",
  },
  MEM4: {
    name: "MEM4 - FC (Memphis, TN)",
    addressLine1: "4055 NEW ALLEN RD",
    addressLine2: "",
    zipCode: "38128",
    city: "MEMPHIS",
    state: "TN",
    country: "US",
    unitNumber: "1T81",
  },
  MEM5: {
    name: "MEM5 - Sort Center (Memphis, TN)",
    addressLine1: "5155 Citation Drive",
    addressLine2: "",
    zipCode: "38118",
    city: "MEMPHIS",
    state: "TN",
    country: "US",
    unitNumber: "1819",
  },
  MEM6: {
    name: "MEM6 - FC NonSort (Olive Branch, MS)",
    addressLine1: "11505 Progress Way",
    addressLine2: "",
    zipCode: "38654",
    city: "OLIVE BRANCH",
    state: "MS",
    country: "US",
    unitNumber: "1T82",
  },
  MGE1: {
    name: "MGE1 - Sortable FC (Braselton, GA)",
    addressLine1: "650 Broadway Avenue",
    addressLine2: "",
    zipCode: "30517",
    city: "Braselton",
    state: "GA",
    country: "US",
    unitNumber: "2403",
  },
  MGE3: {
    name: "MGE3 - NonSort FC (Jefferson, GA)",
    addressLine1: "808 Hog Mountain Road",
    addressLine2: "",
    zipCode: "30549",
    city: "Jefferson",
    state: "GA",
    country: "US",
    unitNumber: "2520",
  },
  MGE5: {
    name: "MGE5 - Sort Center (Jefferson, GA)",
    addressLine1: "235 Hog Mountain Road",
    addressLine2: "",
    zipCode: "30549",
    city: "JEFFERSON",
    state: "GA",
    country: "US",
    unitNumber: "1169",
  },
  MGE8: {
    name: "MGE8 - Sort Center (Atlanta, GA)",
    addressLine1: "4905 DERRICK RD",
    addressLine2: "",
    zipCode: "30349",
    city: "ATLANTA",
    state: "GA",
    country: "US",
    unitNumber: "3B54",
  },
  MGE9: {
    name: "MGE9 - Sort Center (Union City, GA)",
    addressLine1: "6400 Buffington Road",
    addressLine2: "",
    zipCode: "30291",
    city: "Union City",
    state: "GA",
    country: "US",
    unitNumber: "3G27",
  },
  MIA1: {
    name: "MIA1 - Sortable FC ARS (Opa-Locka, FL)",
    addressLine1: "14000 NW 37TH AVE",
    addressLine2: "",
    zipCode: "33054",
    city: "OPA LOCKA",
    state: "FL",
    country: "US",
    unitNumber: "2445",
  },
  MIA2: {
    name: "MIA2 - Sort Center (Opa Locka, FL)",
    addressLine1: "14250 AVIATION DR",
    addressLine2: "",
    zipCode: "33054",
    city: "OPA LOCKA",
    state: "FL",
    country: "US",
    unitNumber: "3G23",
  },
  MIA5: {
    name: "MIA5 - SortCenter (Miami, FL)",
    addressLine1: "1900 NW 132nd Place",
    addressLine2: "",
    zipCode: "33182",
    city: "Miami",
    state: "FL",
    country: "US",
    unitNumber: "1813",
  },
  MIA7: {
    name: "MIA7 - FC (Miami, FL)",
    addressLine1: "1900 NW 132nd Place",
    addressLine2: "",
    zipCode: "33182",
    city: "Miami",
    state: "FL",
    country: "US",
    unitNumber: "3W79",
  },
  MKC2: {
    name: "MKC2 - Sortable FC DISABLED (Lenexa, KS)",
    addressLine1: "14691 W 99th St",
    addressLine2: "",
    zipCode: "66215",
    city: "Lenexa",
    state: "KS",
    country: "US",
    unitNumber: "2808",
  },
  MKC3: {
    name: "MKC3 - Sortable FC (Lenexa, KS)",
    addressLine1: "11011 Lackman Road",
    addressLine2: "",
    zipCode: "66219",
    city: "Lenexa",
    state: "KS",
    country: "US",
    unitNumber: "2809",
  },
  MKC4: {
    name: "MKC4 - NonSort FC (Edgerton, KS)",
    addressLine1: "19400 Montrose St",
    addressLine2: "",
    zipCode: "66021",
    city: "Edgerton",
    state: "KS",
    country: "US",
    unitNumber: "1852",
  },
  MKC6: {
    name: "MKC6 - Sortable FC (Kansas City, KS)",
    addressLine1: "6925 Riverview Avenue",
    addressLine2: "",
    zipCode: "66102",
    city: "Kansas City",
    state: "KS",
    country: "US",
    unitNumber: "2406",
  },
  MKE1: {
    name: "MKE1 - USFC (Kenosha, WI)",
    addressLine1: "3501 120th Ave",
    addressLine2: "",
    zipCode: "53144",
    city: "Kenosha",
    state: "WI",
    country: "US",
    unitNumber: "631",
  },
  MKE2: {
    name: "MKE2 - FC (Milwaukee, WI)",
    addressLine1: "9700 S 13th Street",
    addressLine2: "",
    zipCode: "53154",
    city: "Oak Creek",
    state: "WI",
    country: "US",
    unitNumber: "2115",
  },
  MKE6: {
    name: "MKE6 - Sort Center (Waukegan, IL)",
    addressLine1: "3940 S LAKESIDE DR",
    addressLine2: "",
    zipCode: "60085",
    city: "WAUKEGAN",
    state: "IL",
    country: "US",
    unitNumber: "3G86",
  },
  MLI1: {
    name: "MLI1 - Sortable FC (Davenport, IA)",
    addressLine1: "N DIVISION ST",
    addressLine2: "",
    zipCode: "52806",
    city: "DAVENPORT",
    state: "IA",
    country: "US",
    unitNumber: "7Z83",
  },
  MMU9: {
    name: "MMU9 - FC (Teterboro, NJ)",
    addressLine1: "698 Route 46 West",
    addressLine2: "",
    zipCode: "07608",
    city: "TETERBORO",
    state: "NJ",
    country: "US",
    unitNumber: "3W84",
  },
  MOB5: {
    name: "MOB5 - SortCenter (Mobile, AL)",
    addressLine1: "6735 Trippel Road",
    addressLine2: "",
    zipCode: "36582",
    city: "Theodore",
    state: "AL",
    country: "US",
    unitNumber: "1159",
  },
  MOB9: {
    name: "MOB9 - FC (Theodore, AL)",
    addressLine1: "6735 Trippel Road",
    addressLine2: "",
    zipCode: "36582",
    city: "Theodore",
    state: "AL",
    country: "US",
    unitNumber: "3W80",
  },
  MQJ1: {
    name: "MQJ1 - FC IXD (Greenfield, IN)",
    addressLine1: "4412 W 300 N",
    addressLine2: "",
    zipCode: "46140",
    city: "GREENFIELD",
    state: "IN",
    country: "US",
    unitNumber: "1I98",
  },
  MQJ5: {
    name: "MQJ5 - Sort Center (Plainfield, IN)",
    addressLine1: "1800 Smith Road",
    addressLine2: "",
    zipCode: "46168",
    city: "PLAINFIELD",
    state: "IN",
    country: "US",
    unitNumber: "3G18",
  },
  MQJ9: {
    name: "MQJ9 - Sort Center (Franklin, IN)",
    addressLine1: "120 Jim Black Rd.",
    addressLine2: "",
    zipCode: "46131",
    city: "Franklin",
    state: "IN",
    country: "US",
    unitNumber: "3M46",
  },
  MQY1: {
    name: "MQY1 - FC (Mt. Juliet, TN)",
    addressLine1: "6060 GOLDEN BEAR GTWY",
    addressLine2: "",
    zipCode: "37122",
    city: "MOUNT JULIET",
    state: "TN",
    country: "US",
    unitNumber: "1T80",
  },
  MSP1: {
    name: "MSP1 - Sortable FC (Shakopee, MN)",
    addressLine1: "2601 4th Avenue East",
    addressLine2: "",
    zipCode: "55379",
    city: "Shakopee",
    state: "MN",
    country: "US",
    unitNumber: "1495",
  },
  MSP5: {
    name: "MSP5 - Sort Center (Shakopee, MN)",
    addressLine1: "5825 11th Ave. E",
    addressLine2: "",
    zipCode: "55379",
    city: "Shakopee",
    state: "MN",
    country: "US",
    unitNumber: "1817",
  },
  MSP7: {
    name: "MSP7 - Sort Center (Maple Grove, MN)",
    addressLine1: "10440 89TH AVE N",
    addressLine2: "",
    zipCode: "55369",
    city: "MAPLE GROVE",
    state: "MN",
    country: "US",
    unitNumber: "3G87",
  },
  MSP8: {
    name: "MSP8 - Sort Center (Woodbury, MN)",
    addressLine1: "11975 Hudson Rd",
    addressLine2: "",
    zipCode: "55129",
    city: "WOODBURY",
    state: "MN",
    country: "US",
    unitNumber: "3M51",
  },
  MSP9: {
    name: "MSP9 - Sort Center (Minneapolis, MN)",
    addressLine1: "9001 Wyoming Avenue North",
    addressLine2: "",
    zipCode: "55445",
    city: "Brooklyn Park",
    state: "MN",
    country: "US",
    unitNumber: "1805",
  },
  MTN1: {
    name: "MTN1 - FC Sortable (Wilmington, DE)",
    addressLine1: "1025 BOXWOOD RD",
    addressLine2: "",
    zipCode: "19804",
    city: "WILMINGTON",
    state: "DE",
    country: "US",
    unitNumber: "1W27",
  },
  MTN2: {
    name: "MTN2 - Sort Center (Aberdeen, MD)",
    addressLine1: "913 OLD PHILADELPHIA RD",
    addressLine2: "",
    zipCode: "21001",
    city: "ABERDEEN",
    state: "MD",
    country: "US",
    unitNumber: "3G12",
  },
  MTN3: {
    name: "MTN3 - FC (Sparrows Point, MD)",
    addressLine1: "1701 Finishing Mill Road",
    addressLine2: "",
    zipCode: "21219",
    city: "SPARROWS POINT",
    state: "MD",
    country: "US",
    unitNumber: "3W85",
  },
  MTN5: {
    name: "MTN5 - Sort Center (Baltimore, MD)",
    addressLine1: "5300 Holabird Ave",
    addressLine2: "",
    zipCode: "21224",
    city: "BALTIMORE",
    state: "MD",
    country: "US",
    unitNumber: "1823",
  },
  MTN6: {
    name: "MTN6 - Sort Center (Sparrows Point, MD)",
    addressLine1: "1701 Finishing Mill Road",
    addressLine2: "",
    zipCode: "21219",
    city: "SPARROWS POINT",
    state: "MD",
    country: "US",
    unitNumber: "3G88",
  },
  MTN7: {
    name: "MTN7 - FC (Aberdeen, MD)",
    addressLine1: "913 OLD PHILADELPHIA RD",
    addressLine2: "",
    zipCode: "21001",
    city: "ABERDEEN",
    state: "MD",
    country: "US",
    unitNumber: "3W86",
  },
  MTN8: {
    name: "MTN8 - Sort Center (Hagerstown, MD)",
    addressLine1: "0 Wesel Blvd",
    addressLine2: "",
    zipCode: "21740",
    city: "HAGERSTOWN",
    state: "MD",
    country: "US",
    unitNumber: "3G89",
  },
  MTN9: {
    name: "MTN9 - Sort Center (White Marsh, MD)",
    addressLine1: "5300 Nottingham Road",
    addressLine2: "",
    zipCode: "21236",
    city: "NOTTINGHAM",
    state: "MD",
    country: "US",
    unitNumber: "3B56",
  },
  OAK3: {
    name: "OAK3 - NonSort FC (Patterson, CA)",
    addressLine1: "255 Park Center Drive",
    addressLine2: "",
    zipCode: "95363",
    city: "Patterson",
    state: "CA",
    country: "US",
    unitNumber: "1440",
  },
  OAK4: {
    name: "OAK4 - Sortable FC (Tracy, CA)",
    addressLine1: "1555 N. Chrisman Rd",
    addressLine2: "",
    zipCode: "95304",
    city: "Tracy",
    state: "CA",
    country: "US",
    unitNumber: "1568",
  },
  OAK5: {
    name: "OAK5 - Sort Center (Newark, CA)",
    addressLine1: "38811 Cherry Street",
    addressLine2: "",
    zipCode: "94560",
    city: "Newark",
    state: "CA",
    country: "US",
    unitNumber: "1576",
  },
  OAK7: {
    name: "OAK7 - ReLo FC (Newark, CA)",
    addressLine1: "38811 Cherry St.",
    addressLine2: "",
    zipCode: "94560",
    city: "Newark",
    state: "CA",
    country: "US",
    unitNumber: "1824",
  },
  OAK8: {
    name: "OAK8 - Sortable FC (Livermore, CA)",
    addressLine1: "Golden State FC LLC",
    addressLine2: "",
    zipCode: "94503",
    city: "American Canyon",
    state: "CA",
    country: "US",
    unitNumber: "1849",
  },
  OAK9: {
    name: "OAK9 - FC (Tracy, CA)",
    addressLine1: "6250 PROMONTORY PKWY",
    addressLine2: "",
    zipCode: "95377",
    city: "TRACY",
    state: "CA",
    country: "US",
    unitNumber: "1860",
  },
  OMA2: {
    name: "OMA2 - FC Sortable (Omaha, NE)",
    addressLine1: "14248 HIGHWAY 370",
    addressLine2: "",
    zipCode: "68138",
    city: "OMAHA",
    state: "NE",
    country: "US",
    unitNumber: "1I80",
  },
  OMA5: {
    name: "OMA5 - Sort Center (Council Bluffs, IA)",
    addressLine1: "3860 S. 24th Street",
    addressLine2: "",
    zipCode: "51501",
    city: "Council Bluffs",
    state: "IA",
    country: "US",
    unitNumber: "3G91",
  },
  ONT1: {
    name: "ONT1 - Sort Center (Jurupa Valley, CA)",
    addressLine1: "11200 Iberia Street",
    addressLine2: "",
    zipCode: "91752",
    city: "MIRA LOMA",
    state: "CA",
    country: "US",
    unitNumber: "3B59",
  },
  ONT2: {
    name: "ONT2 - Fresh FC (San Bernardino, CA)",
    addressLine1: "1910 E Central Ave",
    addressLine2: "",
    zipCode: "92408",
    city: "San Bernardino",
    state: "CA",
    country: "US",
    unitNumber: "1422",
  },
  ONT3: {
    name: "ONT3 - MOD (San Bernardino, CA)",
    addressLine1: "1910 E Central Ave",
    addressLine2: "",
    zipCode: "92408",
    city: "San Bernardino",
    state: "CA",
    country: "US",
    unitNumber: "1478",
  },
  ONT5: {
    name: "ONT5 - SortCenter (San Bernardino, CA)",
    addressLine1: "2020 E Central Ave",
    addressLine2: "",
    zipCode: "92408",
    city: "San Bernardino",
    state: "CA",
    country: "US",
    unitNumber: "1557",
  },
  ONT6: {
    name: "ONT6 - Sortable FC (Moreno Valley, CA)",
    addressLine1: "24208 San Michele Rd",
    addressLine2: "",
    zipCode: "92551",
    city: "Moreno Valley",
    state: "CA",
    country: "US",
    unitNumber: "1453",
  },
  ONT8: {
    name: "ONT8 - Receive Center (Moreno Valley, CA)",
    addressLine1: "24300 Nandina Ave",
    addressLine2: "",
    zipCode: "92551",
    city: "Moreno Valley",
    state: "CA",
    country: "US",
    unitNumber: "1801",
  },
  ONT9: {
    name: "ONT9 - NonSort FC (Redlands, CA)",
    addressLine1: "2125 West San Bernardino Ave",
    addressLine2: "",
    zipCode: "92374",
    city: "Redlands",
    state: "CA",
    country: "US",
    unitNumber: "1448",
  },
  ORD2: {
    name: "ORD2 - FC (Channahon, IL)",
    addressLine1: "23714 W Amoco Rd",
    addressLine2: "",
    zipCode: "60410",
    city: "Channahon",
    state: "IL",
    country: "US",
    unitNumber: "2097",
  },
  ORD4: {
    name: "ORD4 - MOD (Monee, IL)",
    addressLine1: "25810 S RIDGELAND AVE",
    addressLine2: "",
    zipCode: "60449",
    city: "MONEE",
    state: "IL",
    country: "US",
    unitNumber: "8137",
  },
  ORD5: {
    name: "ORD5 - Sortable FC (Matteson, IL)",
    addressLine1: "7001 VOLLMER RD",
    addressLine2: "",
    zipCode: "60443",
    city: "MATTESON",
    state: "IL",
    country: "US",
    unitNumber: "1S57",
  },
  ORD9: {
    name: "ORD9 - SortCenter (Channahon, IL)",
    addressLine1: "23700 W. Bluff Road",
    addressLine2: "Bldg A",
    zipCode: "60410",
    city: "CHANNAHON",
    state: "IL",
    country: "US",
    unitNumber: "3A02",
  },
  ORF2: {
    name: "ORF2 - IXD (Chesapeake, VA)",
    addressLine1: "5045 PORTSMOUTH BLVD",
    addressLine2: "",
    zipCode: "23321",
    city: "CHESAPEAKE",
    state: "VA",
    country: "US",
    unitNumber: "1N53",
  },
  ORF3: {
    name: "ORF3 - Sortable FC (Suffolk, VA)",
    addressLine1: "2020 NORTHGATE COMMERCE PKWY",
    addressLine2: "",
    zipCode: "23435",
    city: "SUFFOLK",
    state: "VA",
    country: "US",
    unitNumber: "1320",
  },
  ORF5: {
    name: "ORF5 - Sort Center (Suffolk, VA)",
    addressLine1: "1401 ENTERPRISE DR",
    addressLine2: "",
    zipCode: "23434",
    city: "SUFFOLK",
    state: "VA",
    country: "US",
    unitNumber: "3G93",
  },
  ORH5: {
    name: "ORH5 - Sort Center (Uxbridge, MA)",
    addressLine1: "515 Douglas St",
    addressLine2: "",
    zipCode: "01569",
    city: "Uxbridge",
    state: "MA",
    country: "US",
    unitNumber: "3G17",
  },
  OWD5: {
    name: "OWD5 - Sort Center (Northborough, MA)",
    addressLine1: "330 BARTLETT ST",
    addressLine2: "",
    zipCode: "01532",
    city: "NORTHBOROUGH",
    state: "MA",
    country: "US",
    unitNumber: "3G13",
  },
  OWD9: {
    name: "OWD9 - Sort Center (Northborough, MA)",
    addressLine1: "350 BARTLETT ST",
    addressLine2: "",
    zipCode: "01532",
    city: "NORTHBOROUGH",
    state: "MA",
    country: "US",
    unitNumber: "3G36",
  },
  OXR1: {
    name: "OXR1 - FC Sortable (Oxnard, CA)",
    addressLine1: "3100 Sakioka Dr",
    addressLine2: "",
    zipCode: "93030",
    city: "OXNARD",
    state: "CA",
    country: "US",
    unitNumber: "1I90",
  },
  PAFA: {
    name: "PAFA-AirGW (Fairbanks, AK)",
    addressLine1: "5385 Airport Industrial Rd",
    addressLine2: "",
    zipCode: "99709",
    city: "FAIRBANKS",
    state: "AK",
    country: "US",
    unitNumber: "9Z97",
  },
  PANC: {
    name: "PANC - Air Gateway (Anchorage, AK)",
    addressLine1: "6375 KULIS DR",
    addressLine2: "",
    zipCode: "99502",
    city: "ANCHORAGE",
    state: "AK",
    country: "US",
    unitNumber: "1K09",
  },
  PCA1: {
    name: "PCA1 - ReLo FC (Phoenix, AZ)",
    addressLine1: "7700 W Fillmore",
    addressLine2: "",
    zipCode: "85043",
    city: "PHOENIX",
    state: "AZ",
    country: "US",
    unitNumber: "1343",
  },
  PCA2: {
    name: "PCA2 - FC IXD disabled (Perris, CA)",
    addressLine1: "4501 PATTERSON AVE",
    addressLine2: "",
    zipCode: "92571",
    city: "PERRIS",
    state: "CA",
    country: "US",
    unitNumber: "1348",
  },
  PCA3: {
    name: "PCA3 - FC DISABLED (Fontana, CA)",
    addressLine1: "10681 Production Ave",
    addressLine2: "",
    zipCode: "92337",
    city: "Fontana",
    state: "CA",
    country: "US",
    unitNumber: "2564",
  },
  PCW1: {
    name: "PCW1 - FC (Rossford, OH)",
    addressLine1: "27400 Crossroads Parkway",
    addressLine2: "",
    zipCode: "43460",
    city: "ROSSFORD",
    state: "OH",
    country: "US",
    unitNumber: "1033",
  },
  PDK2: {
    name: "PDK2 - FC (Atlanta, GA)",
    addressLine1: "4905 Derrick Rd",
    addressLine2: "",
    zipCode: "30349",
    city: "ATLANTA",
    state: "GA",
    country: "US",
    unitNumber: "3W81",
  },
  PDX5: {
    name: "PDX5 - SortCenter (Hillsboro, OR)",
    addressLine1: "23677 NW Huffman Street",
    addressLine2: "",
    zipCode: "97124",
    city: "Hillsboro",
    state: "OR",
    country: "US",
    unitNumber: "2212",
  },
  PDX7: {
    name: "PDX7 - Sortable FC TNS (Salem, OR)",
    addressLine1: "4775 DEPOT CT SE",
    addressLine2: "",
    zipCode: "97317",
    city: "SALEM",
    state: "OR",
    country: "US",
    unitNumber: "2528",
  },
  PDX9: {
    name: "PDX9 - Sortable FC ARS (Troutdale, OR)",
    addressLine1: "1250 NW SWIGERT WAY",
    addressLine2: "",
    zipCode: "97060",
    city: "TROUTDALE",
    state: "OR",
    country: "US",
    unitNumber: "2444",
  },
  PFL2: {
    name: "PFL2 - Supplemental FC (Lakeland, FL)",
    addressLine1: "8060 State Rd 33 North",
    addressLine2: "",
    zipCode: "33809",
    city: "Lakeland",
    state: "FL",
    country: "US",
    unitNumber: "2536",
  },
  PGA1: {
    name: "PGA1 - FC IXD (Jefferson, GA)",
    addressLine1: "429 TOY WRIGHT ROAD",
    addressLine2: "",
    zipCode: "30549",
    city: "Jefferson",
    state: "GA",
    country: "US",
    unitNumber: "1347",
  },
  PHKO: {
    name: "PHKO-AirGW (Kailua-Kona, HI)",
    addressLine1: "73-221 U'u St",
    addressLine2: "",
    zipCode: "96740",
    city: "KAILUA KONA",
    state: "HI",
    country: "US",
    unitNumber: "9Z98",
  },
  PHL2: {
    name: "PHL2 - Sortable FC (Chambersburg, PA)",
    addressLine1: "1465 Nitterhouse Dr",
    addressLine2: "",
    zipCode: "17201",
    city: "Chambersburg",
    state: "PA",
    country: "US",
    unitNumber: "1202",
  },
  PHL3: {
    name: "PHL3 - Sortable FC (New Castle, DE)",
    addressLine1: "1600 Johnson Way",
    addressLine2: "",
    zipCode: "19720",
    city: "New Castle",
    state: "DE",
    country: "US",
    unitNumber: "1210",
  },
  PHL4: {
    name: "PHL4 - NonSort FC (Carlisle, PA)",
    addressLine1: "21 Roadway Dr.",
    addressLine2: "",
    zipCode: "17015",
    city: "Carlisle",
    state: "PA",
    country: "US",
    unitNumber: "1203",
  },
  PHL5: {
    name: "PHL5 - NonSort FC (Lewisberry, PA)",
    addressLine1: "500 McCarthy Dr",
    addressLine2: "",
    zipCode: "17339",
    city: "Lewisberry",
    state: "PA",
    country: "US",
    unitNumber: "1204",
  },
  PHL6: {
    name: "PHL6 - NonSort FC (Carlisle, PA)",
    addressLine1: "675 Allen Rd",
    addressLine2: "",
    zipCode: "17015",
    city: "Carlisle",
    state: "PA",
    country: "US",
    unitNumber: "1206",
  },
  PHL7: {
    name: "PHL7 - Sortable FC (Middletown, DE)",
    addressLine1: "560 Merrimac Ave",
    addressLine2: "",
    zipCode: "19709",
    city: "Middletown",
    state: "DE",
    country: "US",
    unitNumber: "1437",
  },
  PHL8: {
    name: "PHL8 - SortCenter (Middletown, DE)",
    addressLine1: "560 Merrimac Ave",
    addressLine2: "",
    zipCode: "19709",
    city: "Middletown",
    state: "DE",
    country: "US",
    unitNumber: "1484",
  },
  PHL9: {
    name: "PHL9 - MOD (Middletown, DE)",
    addressLine1: "560 Merrimac Ave",
    addressLine2: "",
    zipCode: "19709",
    city: "Middletown",
    state: "DE",
    country: "US",
    unitNumber: "1797",
  },
  PHLI: {
    name: "PHLI-AirGW (Lihue, HI)",
    addressLine1: "3759 Ahukini Road",
    addressLine2: "",
    zipCode: "96766",
    city: "LIHUE",
    state: "HI",
    country: "US",
    unitNumber: "9Z70",
  },
  PHOG: {
    name: "PHOG-AirGW (Kahului, HI)",
    addressLine1: "871 Haleakala HwyBay 5",
    addressLine2: "",
    zipCode: "96732",
    city: "KAHULUI",
    state: "HI",
    country: "US",
    unitNumber: "9Z99",
  },
  PHX3: {
    name: "PHX3 - Sortable FC (Phoenix, AZ)",
    addressLine1: "6835 West Buckeye Road",
    addressLine2: "",
    zipCode: "85043",
    city: "Phoenix",
    state: "AZ",
    country: "US",
    unitNumber: "1352",
  },
  PHX5: {
    name: "PHX5 - NonSort FC (Goodyear, AZ)",
    addressLine1: "16920 W. Commerce Dr",
    addressLine2: "",
    zipCode: "85338",
    city: "Goodyear",
    state: "AZ",
    country: "US",
    unitNumber: "1306",
  },
  PHX6: {
    name: "PHX6 - Sortable FC (Phoenix, AZ)",
    addressLine1: "4750 West Mohave St",
    addressLine2: "",
    zipCode: "85043",
    city: "Phoenix",
    state: "AZ",
    country: "US",
    unitNumber: "1307",
  },
  PHX7: {
    name: "PHX7 - NonSort FC (Phoenix, AZ)",
    addressLine1: "800 N 75th Ave",
    addressLine2: "",
    zipCode: "85043",
    city: "Phoenix",
    state: "AZ",
    country: "US",
    unitNumber: "1433",
  },
  PHX9: {
    name: "PHX9 - Sortable FC (Tolleson, AZ)",
    addressLine1: "777 S 79th Ave",
    addressLine2: "",
    zipCode: "85353",
    city: "Tolleson",
    state: "AZ",
    country: "US",
    unitNumber: "1798",
  },
  PIL1: {
    name: "PIL1 - FC IXD disabled (Horn Lake, MS)",
    addressLine1: "1615 COMMERCE PKWY N",
    addressLine2: "",
    zipCode: "38637",
    city: "HORN LAKE",
    state: "MS",
    country: "US",
    unitNumber: "2524",
  },
  PIN1: {
    name: "PIN1 - Supplemental FC (Indianapolis, IN)",
    addressLine1: "5510 Exploration Drive",
    addressLine2: "",
    zipCode: "46241",
    city: "Indianapolis",
    state: "IN",
    country: "US",
    unitNumber: "1794",
  },
  PIT2: {
    name: "PIT2 - Non Sortable FC TNS (Imperial, PA)",
    addressLine1: "1200 Westport Rd",
    addressLine2: "",
    zipCode: "15126",
    city: "IMPERIAL",
    state: "PA",
    country: "US",
    unitNumber: "2426",
  },
  PIT4: {
    name: "PIT4 - FC (Imperial, PA)",
    addressLine1: "17 William Drive",
    addressLine2: "",
    zipCode: "15126",
    city: "IMPERIAL",
    state: "PA",
    country: "US",
    unitNumber: "3W88",
  },
  PIT5: {
    name: "PIT5 - SortCenter (Pittsburgh, PA)",
    addressLine1: "2250 Roswell Drive",
    addressLine2: "",
    zipCode: "15205",
    city: "Pittsburgh",
    state: "PA",
    country: "US",
    unitNumber: "1815",
  },
  PIT9: {
    name: "PIT9 - Sort Center (Imperial, PA)",
    addressLine1: "17 William Drive",
    addressLine2: "",
    zipCode: "15126",
    city: "IMPERIAL",
    state: "PA",
    country: "US",
    unitNumber: "3G22",
  },
  PKC1: {
    name: "PKC1 - Supplemental FC (Edgerton, KS)",
    addressLine1: "30901 W 185th St",
    addressLine2: "",
    zipCode: "66021",
    city: "EDGERTON",
    state: "KS",
    country: "US",
    unitNumber: "4A28",
  },
  PNE5: {
    name: "PNE5 - Sort Center (Robbinsville, NJ)",
    addressLine1: "18 Applegate Drive",
    addressLine2: "",
    zipCode: "08691",
    city: "ROBBINSVILLE",
    state: "NJ",
    country: "US",
    unitNumber: "8050",
  },
  POH1: {
    name: "POH1 - Supplemental FC - Pepsi DISABLED US Sortable (Obetz, OH)",
    addressLine1: "1901 Beggrow St",
    addressLine2: "",
    zipCode: "43137",
    city: "Lockbourne",
    state: "OH",
    country: "US",
    unitNumber: "1342",
  },
  POH2: {
    name: "POH2 - Supplemental FC (Lockbourne, OH)",
    addressLine1: "2155 ROHR RD",
    addressLine2: "",
    zipCode: "43137",
    city: "LOCKBOURNE",
    state: "OH",
    country: "US",
    unitNumber: "4A64",
  },
  PPA1: {
    name: "PPA1 - Supplemental FC - Pepsi US Sortable (Mountaintop, PA)",
    addressLine1: "545 Oak Hill Road",
    addressLine2: "",
    zipCode: "18707",
    city: "Mountaintop",
    state: "PA",
    country: "US",
    unitNumber: "1345",
  },
  PPA2: {
    name: "PPA2 - Supplemental FC (Hanover Township, PA)",
    addressLine1: "1057 Hanover St",
    addressLine2: "",
    zipCode: "18706",
    city: "HANOVER TOWNSHIP",
    state: "PA",
    country: "US",
    unitNumber: "4A27",
  },
  PSP1: {
    name: "PSP1 - FC (Beaumont, CA)",
    addressLine1: "1010 W 4th St",
    addressLine2: "",
    zipCode: "92223",
    city: "Beaumont",
    state: "CA",
    country: "US",
    unitNumber: "2076",
  },
  QXX1: {
    name: "QXX1 - Supplemental FC (North Haven, CT)",
    addressLine1: "409 WASHINGTON AVE",
    addressLine2: "",
    zipCode: "06473",
    city: "NORTH HAVEN",
    state: "CT",
    country: "US",
    unitNumber: "3Q00",
  },
  QXX6: {
    name: "QXX6 - FC Kariba (Joliet, IL)",
    addressLine1: "4300 Brandon Road",
    addressLine2: "",
    zipCode: "60421",
    city: "Joliet",
    state: "IL",
    country: "US",
    unitNumber: "3Q05",
  },
  QXY2: {
    name: "QXY2 - Supplemental FC (Victorville, CA)",
    addressLine1: "18580 GATEWAY DR",
    addressLine2: "",
    zipCode: "92394",
    city: "VICTORVILLE",
    state: "CA",
    country: "US",
    unitNumber: "3Q10",
  },
  QXY8: {
    name: "QXY8 - Supplemental FC (Fresno, CA)",
    addressLine1: "3611 S NORTHPOINTE DR",
    addressLine2: "",
    zipCode: "93725",
    city: "FRESNO",
    state: "CA",
    country: "US",
    unitNumber: "3Q16",
  },
  QXY9: {
    name: "QXY9 - FC Kariba (Beaumont, CA)",
    addressLine1: "36900 W FOURTH ST",
    addressLine2: "",
    zipCode: "92223",
    city: "BEAUMONT",
    state: "CA",
    country: "US",
    unitNumber: "3Q17",
  },
  RAD1: {
    name: "RAD1 - Rapid Asset Deploy't Whse (Antioch, TN)",
    addressLine1: "3818 LOGISTICS WAY",
    addressLine2: "",
    zipCode: "37013",
    city: "ANTIOCH",
    state: "TN",
    country: "US",
    unitNumber: "1K94",
  },
  RDG1: {
    name: "RDG1 - FC Sortable (Hamburg, PA)",
    addressLine1: "3563 Mountain Road",
    addressLine2: "",
    zipCode: "19526",
    city: "HAMBURG",
    state: "PA",
    country: "US",
    unitNumber: "1I96",
  },
  RDU1: {
    name: "RDU1 - FC (Garner, NC)",
    addressLine1: "4851 Jones Sausage Rd",
    addressLine2: "",
    zipCode: "27529",
    city: "GARNER",
    state: "NC",
    country: "US",
    unitNumber: "2071",
  },
  RDU2: {
    name: "RDU2 - FC IXD (Smithfield, NC)",
    addressLine1: "2095 West Market Street",
    addressLine2: "",
    zipCode: "27577",
    city: "SMITHFIELD",
    state: "NC",
    country: "US",
    unitNumber: "1I15",
  },
  RDU5: {
    name: "RDU5 - SortCenter (Raleigh-Durham, NC)",
    addressLine1: "1805 TW Alexander Drive",
    addressLine2: "",
    zipCode: "27703",
    city: "Durham",
    state: "NC",
    country: "US",
    unitNumber: "1087",
  },
  RDU9: {
    name: "RDU9 - Sort Center (Mebane, NC)",
    addressLine1: "13875 Sen Ralph Scott Pkwy",
    addressLine2: "",
    zipCode: "27302",
    city: "GRAHAM",
    state: "NC",
    country: "US",
    unitNumber: "3G95",
  },
  RFD1: {
    name: "RFD1 - MbA (Rockford, IL)",
    addressLine1: "4650 SHEPHERD TRL",
    addressLine2: "",
    zipCode: "61103",
    city: "ROCKFORD",
    state: "IL",
    country: "US",
    unitNumber: "2W82",
  },
  RFD2: {
    name: "RFD2 - FC IXD (Huntley, IL)",
    addressLine1: "41W368 Freeman Road",
    addressLine2: "",
    zipCode: "60142",
    city: "HUNTLEY",
    state: "IL",
    country: "US",
    unitNumber: "2W71",
  },
  RFD3: {
    name: "RFD3 - FC Kariba (Joliet, IL)",
    addressLine1: "4300 Brandon Road",
    addressLine2: "",
    zipCode: "60421",
    city: "Joliet",
    state: "IL",
    country: "US",
    unitNumber: "7Z01",
  },
  RFD7: {
    name: "RFD7 - FC (Channahon, IL)",
    addressLine1: "23700 Bluff Road",
    addressLine2: "",
    zipCode: "60410",
    city: "CHANNAHON",
    state: "IL",
    country: "US",
    unitNumber: "3W75",
  },
  RIC1: {
    name: "RIC1 - NonSort FC (Petersburg, VA)",
    addressLine1: "5000 COMMERCE WAY",
    addressLine2: "",
    zipCode: "23803",
    city: "PETERSBURG",
    state: "VA",
    country: "US",
    unitNumber: "1443",
  },
  RIC2: {
    name: "RIC2 - Sortable FC (Chester, VA)",
    addressLine1: "1901 MEADOWVILLE TECHNOLOGY PKWY",
    addressLine2: "",
    zipCode: "23836",
    city: "CHESTER",
    state: "VA",
    country: "US",
    unitNumber: "1436",
  },
  RIC4: {
    name: "RIC4 - FC Sortable (Richmond, VA)",
    addressLine1: "5901 RICHMOND HENRICO TPKE",
    addressLine2: "",
    zipCode: "23227",
    city: "RICHMOND",
    state: "VA",
    country: "US",
    unitNumber: "1Y67",
  },
  RIC5: {
    name: "RIC5 - SortCenter (Ashland, VA)",
    addressLine1: "11600 E Lakeridge Parkway",
    addressLine2: "",
    zipCode: "23005",
    city: "Ashland",
    state: "VA",
    country: "US",
    unitNumber: "1165",
  },
  RIC9: {
    name: "RIC9 - FC (Ashland, VA)",
    addressLine1: "11600 N Lakeridge Pkwy",
    addressLine2: "",
    zipCode: "23005",
    city: "Ashland",
    state: "VA",
    country: "US",
    unitNumber: "3W87",
  },
  RMN3: {
    name: "RMN3 - FC IXD (Fredericksburg, VA)",
    addressLine1: "220 Centreport Parkway",
    addressLine2: "",
    zipCode: "22406",
    city: "Fredericksburg",
    state: "VA",
    country: "US",
    unitNumber: "2W69",
  },
  RNO1: {
    name: "RNO1 - Sortable FC (Fernley, NV)",
    addressLine1: "1654 E Newlands Dr",
    addressLine2: "",
    zipCode: "89408",
    city: "Fernley",
    state: "NV",
    country: "US",
    unitNumber: "1300",
  },
  RNO3: {
    name: "RNO3 - Sortable FC (McCarran, NV)",
    addressLine1: "555 Milan Drive",
    addressLine2: "",
    zipCode: "89434",
    city: "McCarran",
    state: "NV",
    country: "US",
    unitNumber: "2802",
  },
  RNO4: {
    name: "RNO4 - NonSort FC (Reno, NV)",
    addressLine1: "8000 North Virginia Street",
    addressLine2: "",
    zipCode: "89506",
    city: "Reno",
    state: "NV",
    country: "US",
    unitNumber: "1475",
  },
  ROC1: {
    name: "ROC1 - FC Sortable (Rochester, NY)",
    addressLine1: "2600 MANITOU RD",
    addressLine2: "",
    zipCode: "14653",
    city: "ROCHESTER",
    state: "NY",
    country: "US",
    unitNumber: "2C99",
  },
  ROC5: {
    name: "ROC5 - Sort Center (Gates, NY)",
    addressLine1: "2600 Manitou Road",
    addressLine2: "",
    zipCode: "14624",
    city: "Gates",
    state: "NY",
    country: "US",
    unitNumber: "3G96",
  },
  RSW5: {
    name: "RSW5 - Sort Center (Fort Myers, FL)",
    addressLine1: "0 Alico Road",
    addressLine2: "",
    zipCode: "33912",
    city: "FORT MYERS",
    state: "FL",
    country: "US",
    unitNumber: "3G75",
  },
  SAC5: {
    name: "SAC5 - Sort Center (Sacramento, CA)",
    addressLine1: "8040 METRO AIR PKWY",
    addressLine2: "",
    zipCode: "95836",
    city: "SACRAMENTO",
    state: "CA",
    country: "US",
    unitNumber: "3G98",
  },
  SAN3: {
    name: "SAN3 - FC (San Diego, CA)",
    addressLine1: "6971 OTAY MESA RD",
    addressLine2: "",
    zipCode: "92154",
    city: "SAN DIEGO",
    state: "CA",
    country: "US",
    unitNumber: "2124",
  },
  SAN5: {
    name: "SAN5 - Sort Center (San Diego, CA)",
    addressLine1: "7144 OTAY MESA RD",
    addressLine2: "",
    zipCode: "92154",
    city: "SAN DIEGO",
    state: "CA",
    country: "US",
    unitNumber: "3G21",
  },
  SAN6: {
    name: "SAN6 - Non Sortable FC (San Diego, CA)",
    addressLine1: "6940 Otay Mesa Road",
    addressLine2: "",
    zipCode: "92154",
    city: "San Diego",
    state: "CA",
    country: "US",
    unitNumber: "2W70",
  },
  SAV3: {
    name: "SAV3 - Sortable FC TNS (Macon, GA)",
    addressLine1: "7001 SKIPPER RD",
    addressLine2: "",
    zipCode: "31216",
    city: "MACON",
    state: "GA",
    country: "US",
    unitNumber: "2531",
  },
  SAV4: {
    name: "SAV4 - FC Sortable (Pooler, GA)",
    addressLine1: "800 PINE MEADOW DR",
    addressLine2: "",
    zipCode: "31322",
    city: "POOLER",
    state: "GA",
    country: "US",
    unitNumber: "1Y94",
  },
  SAV7: {
    name: "SAV7 - Kariba (Pooler, GA)",
    addressLine1: "60 TRIPLE B TRL",
    addressLine2: "",
    zipCode: "31322",
    city: "POOLER",
    state: "GA",
    country: "US",
    unitNumber: "8A93",
  },
  SBD1: {
    name: "SBD1 - FC IXD (Bloomington, CA)",
    addressLine1: "3388 S Cactus Ave",
    addressLine2: "",
    zipCode: "92316",
    city: "BLOOMINGTON",
    state: "CA",
    country: "US",
    unitNumber: "1T87",
  },
  SBD2: {
    name: "SBD2 - Sortable FC (San Bernardino, CA)",
    addressLine1: "1494 S WATERMAN AVE",
    addressLine2: "",
    zipCode: "92408",
    city: "SAN BERNARDINO",
    state: "CA",
    country: "US",
    unitNumber: "1V58",
  },
  SBD3: {
    name: "SBD3 - FC IXD (San Bernardino, CA)",
    addressLine1: "5990 N Cajon Blvd",
    addressLine2: "",
    zipCode: "92407",
    city: "SAN BERNARDINO",
    state: "CA",
    country: "US",
    unitNumber: "1I77",
  },
  SBD5: {
    name: "SBD5 - Sort Center (Jurupa Valley, CA)",
    addressLine1: "11100 Iberia Street",
    addressLine2: "",
    zipCode: "91752",
    city: "Jurupa Valley",
    state: "CA",
    country: "US",
    unitNumber: "3M10",
  },
  SBD6: {
    name: "SBD6 - FC Sortable (Chino, CA)",
    addressLine1: "EUCALYPTUS AVE",
    addressLine2: "",
    zipCode: "91708",
    city: "CHINO",
    state: "CA",
    country: "US",
    unitNumber: "1I72",
  },
  SCA2: {
    name: "SCA2 - SSD FC (Brisbane, CA)",
    addressLine1: "12453 SAN PABLO AVE",
    addressLine2: "",
    zipCode: "94805",
    city: "RICHMOND",
    state: "CA",
    country: "US",
    unitNumber: "1N22",
  },
  SCK1: {
    name: "SCK1 - FC (Stockton, CA)",
    addressLine1: "4532 NEWCASTLE RD",
    addressLine2: "",
    zipCode: "95215",
    city: "STOCKTON",
    state: "CA",
    country: "US",
    unitNumber: "2136",
  },
  SCK4: {
    name: "SCK4 - IXD FC (Stockton, CA)",
    addressLine1: "6001 S AUSTIN RD",
    addressLine2: "",
    zipCode: "95215",
    city: "STOCKTON",
    state: "CA",
    country: "US",
    unitNumber: "1I83",
  },
  SCK6: {
    name: "SCK6 - FC Sortable (Tracy, CA)",
    addressLine1: "1500 East Grant Line Rd",
    addressLine2: "",
    zipCode: "95304",
    city: "TRACY",
    state: "CA",
    country: "US",
    unitNumber: "1I20",
  },
  SCK8: {
    name: "SCK8 - FC Sortable IXD (Oakley, CA)",
    addressLine1: "4700 WILBUR AVE",
    addressLine2: "",
    zipCode: "94561",
    city: "OAKLEY",
    state: "CA",
    country: "US",
    unitNumber: "7Z43",
  },
  SCK9: {
    name: "SCK9 - Sort Center (Stockton, CA)",
    addressLine1: "4601 NEWCASTLE RD",
    addressLine2: "",
    zipCode: "95215",
    city: "STOCKTON",
    state: "CA",
    country: "US",
    unitNumber: "3G05",
  },
  SDF1: {
    name: "SDF1 - Sortable FC (Campbellsville, KY)",
    addressLine1: "1050 South Columbia Ave",
    addressLine2: "",
    zipCode: "42718",
    city: "Campbellsville",
    state: "KY",
    country: "US",
    unitNumber: "1100",
  },
  SDF2: {
    name: "SDF2 - Sortable FC (Louisville, KY)",
    addressLine1: "4360 Robards Lane",
    addressLine2: "",
    zipCode: "40218",
    city: "Louisville",
    state: "KY",
    country: "US",
    unitNumber: "1101",
  },
  SDF4: {
    name: "SDF4 - Zappos FC (Shepherdsville, KY)",
    addressLine1: "376 Zappos.com Blvd",
    addressLine2: "",
    zipCode: "40165",
    city: "Shepherdsville",
    state: "KY",
    country: "US",
    unitNumber: "2606",
  },
  SDF6: {
    name: "SDF6 - ReLo FC (Shepherdsville, KY)",
    addressLine1: "100 W THOMAS P ECHOLS LNSTE 4",
    addressLine2: "",
    zipCode: "40165",
    city: "Shepherdsville",
    state: "KY",
    country: "US",
    unitNumber: "2607",
  },
  SDF7: {
    name: "SDF7 - Zappos FC (Shepherdsville, KY)",
    addressLine1: "300 Omicron Ct",
    addressLine2: "",
    zipCode: "40165",
    city: "Shepherdsville",
    state: "KY",
    country: "US",
    unitNumber: "2608",
  },
  SDF8: {
    name: "SDF8 - Sortable FC (Jeffersonville, IN)",
    addressLine1: "900 Patrol Rd",
    addressLine2: "",
    zipCode: "47130",
    city: "Jeffersonville",
    state: "IN",
    country: "US",
    unitNumber: "1423",
  },
  SDF9: {
    name: "SDF9 - ReLo FC (Shepherdsville, KY)",
    addressLine1: "100 W. Thomas P. Echols Lane",
    addressLine2: "",
    zipCode: "40165",
    city: "Shepherdsville",
    state: "KY",
    country: "US",
    unitNumber: "2613",
  },
  SDL2: {
    name: "SDL2 - FC (Litchfield Park, AZ)",
    addressLine1: "6395 N. Sarival Road",
    addressLine2: "",
    zipCode: "85340",
    city: "LITCHFIELD PARK",
    state: "AZ",
    country: "US",
    unitNumber: "3W64",
  },
  SDM4: {
    name: "SDM4 - FC (San Diego, CA)",
    addressLine1: "7144 OTAY MESA RD",
    addressLine2: "",
    zipCode: "92154",
    city: "SAN DIEGO",
    state: "CA",
    country: "US",
    unitNumber: "3W66",
  },
  SJC7: {
    name: "SJC7 - NonSort FC (Tracy, CA)",
    addressLine1: "188 Mountain House Parkway",
    addressLine2: "",
    zipCode: "95377",
    city: "Tracy",
    state: "CA",
    country: "US",
    unitNumber: "1857",
  },
  SLC1: {
    name: "SLC1 - Sortable FC ARS (Salt Lake City, UT)",
    addressLine1: "777 N 5600 W",
    addressLine2: "",
    zipCode: "84116",
    city: "Salt Lake City",
    state: "UT",
    country: "US",
    unitNumber: "2519",
  },
  SLC2: {
    name: "SLC2 - FC TNS (West Jordan, UT)",
    addressLine1: "7148 W OLD BINGHAM HWY",
    addressLine2: "",
    zipCode: "84081",
    city: "West Jordan",
    state: "UT",
    country: "US",
    unitNumber: "1B65",
  },
  SLC4: {
    name: "SLC4 - MbA (Salt Lake City, UT)",
    addressLine1: "770 S GLADIOLA ST",
    addressLine2: "STE 500",
    zipCode: "84104",
    city: "SALT LAKE CITY",
    state: "UT",
    country: "US",
    unitNumber: "1H61",
  },
  SLC9: {
    name: "SLC9 - Sort Center (Salt Lake City, UT)",
    addressLine1: "808 N 6550 W",
    addressLine2: "",
    zipCode: "84116",
    city: "SALT LAKE CITY",
    state: "UT",
    country: "US",
    unitNumber: "3C99",
  },
  SMF1: {
    name: "SMF1 - Sortable FC (Sacramento, CA)",
    addressLine1: "4900 W Elkhorn Blvd",
    addressLine2: "",
    zipCode: "95835",
    city: "Sacramento",
    state: "CA",
    country: "US",
    unitNumber: "2409",
  },
  SMF3: {
    name: "SMF3 - Sortable FC IXD (Stockton, CA)",
    addressLine1: "3923 B Street",
    addressLine2: "",
    zipCode: "95206",
    city: "Stockton",
    state: "CA",
    country: "US",
    unitNumber: "2525",
  },
  SMF5: {
    name: "SMF5 - SortCenter (Vacaville, CA)",
    addressLine1: "300 Crocker Drive",
    addressLine2: "",
    zipCode: "95688",
    city: "Vacaville",
    state: "CA",
    country: "US",
    unitNumber: "1158",
  },
  SMF6: {
    name: "SMF6 - Non Sortable FC TNS (Sacramento, CA)",
    addressLine1: "4930 ALLBAUGH DR",
    addressLine2: "",
    zipCode: "95837",
    city: "SACRAMENTO",
    state: "CA",
    country: "US",
    unitNumber: "1I35",
  },
  SMF9: {
    name: "SMF9 - FC (Vacaville, CA)",
    addressLine1: "300 Crocker Dr",
    addressLine2: "",
    zipCode: "95688",
    city: "Vacaville",
    state: "CA",
    country: "US",
    unitNumber: "3W65",
  },
  SNA4: {
    name: "SNA4 - NonSort FC (Rialto, CA)",
    addressLine1: "2496 W Walnut Ave",
    addressLine2: "",
    zipCode: "92376",
    city: "Rialto",
    state: "CA",
    country: "US",
    unitNumber: "1799",
  },
  STL3: {
    name: "STL3 - FC TNS (Republic, MO)",
    addressLine1: "3200 E Sawyer Rd",
    addressLine2: "",
    zipCode: "65738",
    city: "Republic",
    state: "MO",
    country: "US",
    unitNumber: "1I11",
  },
  STL4: {
    name: "STL4 - NonSort FC (Edwardsville, IL)",
    addressLine1: "3050 GATEWAY COMMERCE CENTER DR S",
    addressLine2: "",
    zipCode: "62025",
    city: "Edwardsville",
    state: "IL",
    country: "US",
    unitNumber: "1853",
  },
  STL5: {
    name: "STL5 - SortCenter (Hazelwood, MO)",
    addressLine1: "462 Hazelwood Logistics Center Drive",
    addressLine2: "",
    zipCode: "63042",
    city: "Hazelwood",
    state: "MO",
    country: "US",
    unitNumber: "1086",
  },
  STL8: {
    name: "STL8 - FC (St. Peters, MO)",
    addressLine1: "4000 Premier Parkway",
    addressLine2: "",
    zipCode: "63376",
    city: "SAINT PETERS",
    state: "MO",
    country: "US",
    unitNumber: "2063",
  },
  STL9: {
    name: "STL9 - Sort Center (Berkeley, MO)",
    addressLine1: "8850 Springdale Ave",
    addressLine2: "",
    zipCode: "63134",
    city: "Berkeley",
    state: "MO",
    country: "US",
    unitNumber: "3G99",
  },
  STP2: {
    name: "STP2 - FC (Maple Grove, MN)",
    addressLine1: "10655 COUNTY ROAD 81",
    addressLine2: "",
    zipCode: "55369",
    city: "MAPLE GROVE",
    state: "MN",
    country: "US",
    unitNumber: "3W73",
  },
  SWF1: {
    name: "SWF1 - Sortable FC TNS (Rock Tavern, NY)",
    addressLine1: "635 INTERNATIONAL BLVD",
    addressLine2: "",
    zipCode: "12575",
    city: "ROCK TAVERN",
    state: "NY",
    country: "US",
    unitNumber: "2082",
  },
  SWF2: {
    name: "SWF2 - FC IXD (East Fishkill, NY)",
    addressLine1: "1940 ROUTE 52",
    addressLine2: "",
    zipCode: "12533",
    city: "EAST FISHKILL",
    state: "NY",
    country: "US",
    unitNumber: "1Y75",
  },
  SYR1: {
    name: "SYR1- Sortable FC AR (Liverpool, NY)",
    addressLine1: "7211 MORGAN RD",
    addressLine2: "",
    zipCode: "13090",
    city: "LIVERPOOL",
    state: "NY",
    country: "US",
    unitNumber: "1K17",
  },
  TAO1: {
    name: "TAO1 - Sortable FC (Qingdao, CN)",
    addressLine1: "401 MILFORD PARKWAY",
    addressLine2: "",
    zipCode: "45150",
    city: "MILFORD",
    state: "CN",
    country: "US",
    unitNumber: "3143",
  },
  TCY5: {
    name: "TCY5 - Sort Center (Tracy, CA)",
    addressLine1: "2250 Promontory Pkwy",
    addressLine2: "",
    zipCode: "95377",
    city: "TRACY",
    state: "CA",
    country: "US",
    unitNumber: "3B73",
  },
  TCY9: {
    name: "TCY9 - Sort Center (Oakley, CA)",
    addressLine1: "4500 Wilbur Ave",
    addressLine2: "",
    zipCode: "94561",
    city: "OAKLEY",
    state: "CA",
    country: "US",
    unitNumber: "3G60",
  },
  TEB3: {
    name: "TEB3 - NonSort FC TNS (Logan Township, NJ)",
    addressLine1: "2651 Oldmans Creek Rd",
    addressLine2: "",
    zipCode: "08085",
    city: "Logan Township",
    state: "NJ",
    country: "US",
    unitNumber: "2419",
  },
  TEB4: {
    name: "TEB4 - NonSort FC (Penns Grove, NJ)",
    addressLine1: "747 COURSES LANDING RD",
    addressLine2: "",
    zipCode: "08069",
    city: "PENNS GROVE",
    state: "NJ",
    country: "US",
    unitNumber: "1W23",
  },
  TEB6: {
    name: "TEB6 - NonSort FC TNS (Cranbury Township, NJ)",
    addressLine1: "22 Hightstown Cranbury State Road",
    addressLine2: "",
    zipCode: "08512",
    city: "Cranbury",
    state: "NJ",
    country: "US",
    unitNumber: "2424",
  },
  TEB9: {
    name: "TEB9 - FC IXD (Somerset, NJ)",
    addressLine1: "601 Randolph Road",
    addressLine2: "",
    zipCode: "08873",
    city: "SOMERSET",
    state: "NJ",
    country: "US",
    unitNumber: "2079",
  },
  TEN1: {
    name: "TEN1 - ReLo FC (Reading, PA)",
    addressLine1: "1002 PATRIOT PKWY",
    addressLine2: "",
    zipCode: "19605",
    city: "READING",
    state: "PA",
    country: "US",
    unitNumber: "1I30",
  },
  TEN2: {
    name: "TEN2 - FC IXD disabled (Rialto, CA)",
    addressLine1: "1590 TAMARIND AVE",
    addressLine2: "",
    zipCode: "92376",
    city: "RIALTO",
    state: "CA",
    country: "US",
    unitNumber: "1I31",
  },
  TLH2: {
    name: "TLH2 - Sortable FC (Tallahassee, FL)",
    addressLine1: "2635 VINELAND DR",
    addressLine2: "",
    zipCode: "32308",
    city: "TALLAHASSEE",
    state: "FL",
    country: "US",
    unitNumber: "7Z85",
  },
  TPA1: {
    name: "TPA1 - Sortable FC (Tampa, FL)",
    addressLine1: "3350 Laurel Ridge Ave.",
    addressLine2: "",
    zipCode: "33570",
    city: "Ruskin",
    state: "FL",
    country: "US",
    unitNumber: "1420",
  },
  TPA2: {
    name: "TPA2 - NonSort FC (Lakeland, FL)",
    addressLine1: "1760 County Line Rd",
    addressLine2: "",
    zipCode: "33811",
    city: "Lakeland",
    state: "FL",
    country: "US",
    unitNumber: "1446",
  },
  TPA3: {
    name: "TPA3 - NonSort FC (Auburndale, FL)",
    addressLine1: "676 C FRED JONES BLVD",
    addressLine2: "",
    zipCode: "33823",
    city: "AUBURNDALE",
    state: "FL",
    country: "US",
    unitNumber: "1T83",
  },
  TPA4: {
    name: "TPA4 - Sortable FC ARS (Temple Terrace, FL)",
    addressLine1: "8727 Harney Road",
    addressLine2: "",
    zipCode: "33637",
    city: "Temple Terrace",
    state: "FL",
    country: "US",
    unitNumber: "1V60",
  },
  TUL1: {
    name: "TUL1 - Sortable FC DISABLED (Coffeyville, KS)",
    addressLine1: "Coffeyville Ind. Park2654 N. Highway 169",
    addressLine2: "",
    zipCode: "67337",
    city: "Coffeyville",
    state: "KS",
    country: "US",
    unitNumber: "1050",
  },
  TUS1: {
    name: "TUS1 - ReLo FC (Phoenix, AZ)",
    addressLine1: "5333 W. Lower Buckeye Road",
    addressLine2: "",
    zipCode: "85043",
    city: "Phoenix",
    state: "AZ",
    country: "US",
    unitNumber: "2522",
  },
  TUS2: {
    name: "TUS2 - FC (Tucson, AZ)",
    addressLine1: "6701 S KOLB RD",
    addressLine2: "",
    zipCode: "85756",
    city: "TUCSON",
    state: "AZ",
    country: "US",
    unitNumber: "2064",
  },
  TUS5: {
    name: "TUS5 - Sort Center (Tucson, AZ)",
    addressLine1: "3590 E. Corona Road",
    addressLine2: "",
    zipCode: "85756",
    city: "TUCSON",
    state: "AZ",
    country: "US",
    unitNumber: "3M05",
  },
  TYS1: {
    name: "TYS1 - FC Sortable (Rockford, TN)",
    addressLine1: "4101 S SINGLETON STATION RD",
    addressLine2: "",
    zipCode: "37853",
    city: "ROCKFORD",
    state: "TN",
    country: "US",
    unitNumber: "1Y86",
  },
  TYS5: {
    name: "TYS5 - Sort Center (Maryville, TN)",
    addressLine1: "210 Partnership Parkway",
    addressLine2: "",
    zipCode: "37801",
    city: "Maryville",
    state: "TN",
    country: "US",
    unitNumber: "3G82",
  },
  UNC4: {
    name: "UNC4 - Fulfillment Center (Raleigh, NC)",
    addressLine1: "4205 Global Street",
    addressLine2: "",
    zipCode: "27606",
    city: "Raleigh",
    state: "NC",
    country: "US",
    unitNumber: "1P68",
  },
  VEAT: {
    name: "VEAT - Air Gateway (Agartala, TR, IN)",
    addressLine1: "5400 B Westpark Dr",
    addressLine2: "",
    zipCode: "30336",
    city: "Atlanta",
    state: "TR",
    country: "US",
    unitNumber: "9Z37",
  },
  VGT1: {
    name: "VGT1 - FC Sortable (Las Vegas, NV)",
    addressLine1: "5802 E TROPICAL PKWY",
    addressLine2: "",
    zipCode: "89115",
    city: "LAS VEGAS",
    state: "NV",
    country: "US",
    unitNumber: "1Y92",
  },
  VGT2: {
    name: "VGT2 - FC IXD (Las Vegas, NV)",
    addressLine1: "6401 Howdy Wells Ave",
    addressLine2: "",
    zipCode: "89115",
    city: "LAS VEGAS",
    state: "NV",
    country: "US",
    unitNumber: "1Y59",
  },
  VGT5: {
    name: "VGT5 - Sort Center (Las Vegas, NV)",
    addressLine1: "6501 Howdy WellsPrologis Speedway",
    addressLine2: " Bldg 6",
    zipCode: "89115",
    city: "LAS VEGAS",
    state: "NV",
    country: "US",
    unitNumber: "3G83",
  },
  XCA2: {
    name: "XCA2 - LTL (City of Industry, CA)",
    addressLine1: "15120 Valley Blvd",
    addressLine2: "",
    zipCode: "91746",
    city: "LA PUENTE",
    state: "CA",
    country: "US",
    unitNumber: "3M99",
  },
  XIX1: {
    name: "XIX1 - Amazon Inbound Consolidation (AIC) (Robbinsville, NJ)",
    addressLine1: "18 Applegate Drive",
    addressLine2: "",
    zipCode: "08691",
    city: "Robbinsville",
    state: "NJ",
    country: "US",
    unitNumber: "6J54",
  },
  XIX4: {
    name: "XIX4 - Amazon Inbound Consolidation (AIC) (Memphis, TN)",
    addressLine1: "5155 Citation Drive",
    addressLine2: "",
    zipCode: "38118",
    city: "MEMPHIS",
    state: "TN",
    country: "US",
    unitNumber: "6J56",
  },
  XLX1: {
    name: "XLX1 - Amazon XLIXD (Hagerstown, MD)",
    addressLine1: "1115 Wesel Blvd",
    addressLine2: "",
    zipCode: "21740",
    city: "Hagerstown",
    state: "MD",
    country: "US",
    unitNumber: "1Z68",
  },
  XLX6: {
    name: "XLX6 - Amazon XLIXD (Pineville, NC)",
    addressLine1: "12220 Carolina Logistics Drive",
    addressLine2: "",
    zipCode: "28134",
    city: "PINEVILLE",
    state: "NC",
    country: "US",
    unitNumber: "6J01",
  },
  XLX7: {
    name: "XLX7 - AMXL IXD (Victorville, CA)",
    addressLine1: "18580 GATEWAY DR",
    addressLine2: "",
    zipCode: "92394",
    city: "VICTORVILLE",
    state: "CA",
    country: "US",
    unitNumber: "7V00",
  },
  XUSU: {
    name: "XUSU - HB3PL (Rock Hill, SC)",
    addressLine1: "845 Paragon Way",
    addressLine2: "",
    zipCode: "29730",
    city: "Rock Hill",
    state: "SC",
    country: "US",
    unitNumber: "2088",
  },
  ZAP2: {
    name: "ZAP2 - Fulfillment Center (Louisville, KY)",
    addressLine1: "9101 Minor Lane",
    addressLine2: "Suite 2",
    zipCode: "40219",
    city: "LOUISVILLE",
    state: "KY",
    country: "US",
    unitNumber: "5841",
  },
  ZAP3: {
    name: "ZAP3 - Zappos FC (Louisville, KY)",
    addressLine1: "12415 OLD LAGRANGE RD",
    addressLine2: "",
    zipCode: "40245",
    city: "LOUISVILLE",
    state: "KY",
    country: "US",
    unitNumber: "9S26",
  },
};
